"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.v1_ExpandCategories_ClickedProperties = exports.v1_EscapeHatch_ClickedProperties = exports.v1_EscapeHatchEntry_ViewedProperties = exports.v1_EmploymentInfo_ViewedProperties = exports.v1_EmploymentInfo_SubmittedProperties = exports.v1_EmploymentInfoEntry_ViewedProperties = exports.v1_Email_SubmittedProperties = exports.v1_Document_ClickedProperties = exports.v1_DiversificationAnalysis_ClickedProperties = exports.v1_DiversificationAnalysisInfo_ClickedProperties = exports.v1_DiversificationAnalysisAssetClass_ClickedProperties = exports.v1_DirectDepositCard_ViewedProperties = exports.v1_DirectDepositCard_ClickedProperties = exports.v1_DepositSetup_SucceededProperties = exports.v1_DepositSetup_SubmittedProperties = exports.v1_DepositSetup_FailedProperties = exports.v1_DepositSetup_ClickedProperties = exports.v1_Definition_ClickedProperties = exports.v1_ContributionSetup_ViewedProperties = exports.v1_ContributionSetup_CompletedProperties = exports.v1_ContactStashSupport_ViewedProperties = exports.v1_ContactStashSupport_ClickedProperties = exports.v1_ContactStashSupportStart_ClickedProperties = exports.v1_ConfirmPII_ViewedProperties = exports.v1_ConfirmPII_SubmittedProperties = exports.v1_Collection_ClickedProperties = exports.v1_CoachModule_ViewedProperties = exports.v1_CoachModule_ClickedProperties = exports.v1_CoachFeedback_SubmittedProperties = exports.v1_CoachFeedback_ClickedProperties = exports.v1_CoachFeedbackCancel_ClickedProperties = exports.v1_CoachFeed_ViewedProperties = exports.v1_CoachFeedEntryPoint_ClickedProperties = exports.v1_ChooseDocument_ViewedProperties = exports.v1_Category_ClickedProperties = exports.v1_CancelSubscriptionResults_ViewedProperties = exports.v1_CONTEXT = exports.v1_Buy_SucceededProperties = exports.v1_Buy_SubmittedProperties = exports.v1_Buy_FailedProperties = exports.v1_BuySucceeded_ViewedProperties = exports.v1_BuySetup_ViewedProperties = exports.v1_BuySetup_SucceededProperties = exports.v1_BuySetup_SubmittedProperties = exports.v1_BuySetup_FailedProperties = exports.v1_BuySetup_ClickedProperties = exports.v1_BuySetupResults_ViewedProperties = exports.v1_BuyOptions_ViewedProperties = exports.v1_BuyOptions_ClickedProperties = exports.v1_BuyConfirmation_ViewedProperties = exports.v1_BuyAmountEntry_ViewedProperties = exports.v1_BrowseInvestments_ViewedProperties = exports.v1_BrowseInvestments_ClickedProperties = exports.v1_AutoStashResume_SubmittedProperties = exports.v1_AutoStashResume_ClickedProperties = exports.v1_AutoStashResumeConfirmation_ViewedProperties = exports.v1_AutoStashRemoveAllocation_ClickedProperties = exports.v1_AutoStashProjection_ViewedProperties = exports.v1_AutoStashProjection_ClickedProperties = exports.v1_AutoStashPause_ClickedProperties = exports.v1_AutoStashPauseSetup_ViewedProperties = exports.v1_AutoStashPauseSetup_SucceededProperties = exports.v1_AutoStashPauseSetup_SubmittedProperties = exports.v1_AutoStashPauseSetup_FailedProperties = exports.v1_AutoStashModule_ViewedProperties = exports.v1_AutoStashModule_ClickedProperties = exports.v1_AutoStashModify_ViewedProperties = exports.v1_AutoStashModify_SucceededProperties = exports.v1_AutoStashModify_SubmittedProperties = exports.v1_AutoStashModify_FailedProperties = exports.v1_AutoStashModify_ClickedProperties = exports.v1_AutoStashModifyResult_ViewedProperties = exports.v1_AutoStashHome_ClickedProperties = exports.v1_AutoStashDisableSpeedbump_ViewedProperties = exports.v1_AutoStashDisableContinue_ClickedProperties = exports.v1_AutoStashDetails_ViewedProperties = exports.v1_AutoStashDetails_ClickedProperties = exports.v1_AppSession_StartedProperties = exports.v1_AiChat_ViewedProperties = exports.v1_AiChat_SubmittedProperties = exports.v1_AiChat_FailedProperties = exports.v1_AiChat_ClosedProperties = exports.v1_AiChatSuggestedTopic_ClickedProperties = exports.v1_AiChatFlag_ProcessedProperties = exports.v1_AiChatEntryPoint_ClickedProperties = exports.v1_AiChatDisclosureLink_ClickedProperties = exports.v1_AiChatCTA_ClickedProperties = exports.v1_AiChatAgentLink_ClickedProperties = exports.v1_AdvisoryEsig_ViewedProperties = exports.v1_AdvisoryEsig_SubmittedProperties = exports.v1_Address_SucceededProperties = exports.v1_Address_SubmittedProperties = exports.v1_AddressEntry_ViewedProperties = exports.v1_AddAccount_ViewedProperties = exports.v1_AddAccount_ClickedProperties = exports.v1_AccountSetup_ClickedProperties = exports.v1_AccountOpen_ClickedProperties = exports.v1_AccountDetails_ClickedProperties = exports.v1_AccountAgreement_ViewedProperties = exports.v1_AccountAgreement_SubmittedProperties = void 0;
exports.v1_PersonalPick_ClickedProperties = exports.v1_PersonalDetails_SubmittedProperties = exports.v1_PersonalDetailsEntry_ViewedProperties = exports.v1_PIIEntry_ViewedProperties = exports.v1_PIIEntry_SubmittedProperties = exports.v1_OtherAccountsInfo_ClickedProperties = exports.v1_Offer_ViewedProperties = exports.v1_OfferAccepted_ClickedProperties = exports.v1_MyStashSection_FailedProperties = exports.v1_MyStashSectionFailed_ViewedProperties = exports.v1_MyStashModule_ViewedProperties = exports.v1_MyStashModuleInfo_ClickedProperties = exports.v1_MyStashHome_ClickedProperties = exports.v1_MyStashHomeAccountsSummary_ViewedProperties = exports.v1_MyGoalsModule_ViewedProperties = exports.v1_MoneyMovement_ClickedProperties = exports.v1_MoneyMovementSource_ViewedProperties = exports.v1_MoneyMovementSetup_ViewedProperties = exports.v1_MoneyMovementResults_ViewedProperties = exports.v1_MoneyMovementLimits_ViewedProperties = exports.v1_MoneyMovementLimits_ClickedProperties = exports.v1_MoneyMovementDestination_ViewedProperties = exports.v1_MoneyMovementConfirmation_ViewedProperties = exports.v1_MicroDepositResend_SubmittedProperties = exports.v1_MicroDepositConfirmation_ViewedProperties = exports.v1_MicroDepositConfirmation_SubmittedProperties = exports.v1_MicroDepositConfirmation_FailedProperties = exports.v1_MicroDepositConfirmation_ClickedProperties = exports.v1_Logout_SucceededProperties = exports.v1_Login_ClickedProperties = exports.v1_LearnContentMoat_ClickedProperties = exports.v1_LearnAndEarn_ViewedProperties = exports.v1_LearnAndEarn_SubmittedProperties = exports.v1_LearnAndEarn_CompletedProperties = exports.v1_LearnAndEarn_ClickedProperties = exports.v1_LearnAndEarnAction_ClickedProperties = exports.v1_LandingPage_ViewedProperties = exports.v1_LandingPage_ClickedProperties = exports.v1_InvestmentDetails_ViewedProperties = exports.v1_InvestmentDetails_ClickedProperties = exports.v1_InvestmentDetailsPartial_ViewedProperties = exports.v1_InvestmentDetailsPartial_ClickedProperties = exports.v1_InvestingTips_ViewedProperties = exports.v1_InvestingTips_ClickedProperties = exports.v1_InvestingQuestions_SubmittedProperties = exports.v1_InvestingQuestionsEntry_ViewedProperties = exports.v1_InvestPerformanceInfo_ClickedProperties = exports.v1_InternalTransferSetup_SucceededProperties = exports.v1_InternalTransferSetup_SubmittedProperties = exports.v1_InternalTransferSetup_FailedProperties = exports.v1_InternalNotification_ViewedProperties = exports.v1_InternalNotificationDismiss_ClickedProperties = exports.v1_InternalNotificationAction_ClickedProperties = exports.v1_IdentifyProperties = exports.v1_IDVResult_ViewedProperties = exports.v1_IDVResult_ClickedProperties = exports.v1_IDVMiskey_ViewedProperties = exports.v1_IDVMiskey_SubmittedProperties = exports.v1_IDVEntry_ViewedProperties = exports.v1_IDVCapture_ViewedProperties = exports.v1_IDVCapture_ClickedProperties = exports.v1_IDVCaptureConfirmation_ViewedProperties = exports.v1_IDVCaptureConfirmation_ClickedProperties = exports.v1_Home_FailedProperties = exports.v1_HodorVerification_SucceededProperties = exports.v1_HideCategories_ClickedProperties = exports.v1_Graph_ClickedProperties = exports.v1_GraphTimeframe_ClickedProperties = exports.v1_GoalsInfo_ClickedProperties = exports.v1_GoalsHome_ViewedProperties = exports.v1_Goal_SubmittedProperties = exports.v1_GoalDetails_ViewedProperties = exports.v1_GoalDetails_ClickedProperties = exports.v1_GoalDetailEdit_ClickedProperties = exports.v1_GoalDetailDelete_ClickedProperties = exports.v1_GoalDetailDeleteOption_ClickedProperties = exports.v1_GoalCreateTargets_ViewedProperties = exports.v1_GoalCreateStart_ClickedProperties = exports.v1_GoalCreateName_ClickedProperties = exports.v1_GoalCreateNameEntry_ViewedProperties = exports.v1_GoalCreateCancel_ClickedProperties = exports.v1_GoalCreateCancelOption_ClickedProperties = exports.v1_FinraAffiliate_ViewedProperties = exports.v1_FinraAffiliate_SubmittedProperties = exports.v1_ExternalAccountLink_ViewedProperties = exports.v1_ExternalAccountLink_ClickedProperties = exports.v1_ExternalAccountLinkStart_ViewedProperties = exports.v1_ExternalAccountLinkStart_ClickedProperties = exports.v1_ExternalAccountLinkSetup_ViewedProperties = exports.v1_ExternalAccountLinkSetup_SucceededProperties = exports.v1_ExternalAccountLinkSetup_SubmittedProperties = exports.v1_ExternalAccountLinkSetup_FailedProperties = exports.v1_ExternalAccountLinkSetup_ClosedProperties = exports.v1_ExternalAccountLinkSetupResults_ViewedProperties = exports.v1_ExternalAccountLinkProcessing_ViewedProperties = exports.v1_ExternalAccountLinkPrimer_ClickedProperties = exports.v1_ExternalAccountLinkFailed_ViewedProperties = exports.v1_ExternalAccountChooseBank_ClickedProperties = exports.v1_ExternalAccountChasePartial_ClickedProperties = exports.v1_Experiment_ViewedProperties = void 0;
exports.v1_VerifyMicros_ViewedProperties = exports.v1_UserSignup_ViewedProperties = exports.v1_UserSignup_SubmittedProperties = exports.v1_UserSignup_ClickedProperties = exports.v1_UserProfile_ViewedProperties = exports.v1_UserProfile_ClickedProperties = exports.v1_UserIntentQuestion_ViewedProperties = exports.v1_UserIntentQuestion_SubmittedProperties = exports.v1_UserIdLog_SubmittedProperties = exports.v1_UpgradeModule_ViewedProperties = exports.v1_UpgradeModule_ClickedProperties = exports.v1_TrustedContact_SubmittedProperties = exports.v1_TrustedContact_ClickedProperties = exports.v1_TrustedContactEntry_ViewedProperties = exports.v1_TotalValueInfo_ClickedProperties = exports.v1_SubscriptionPlan_ViewedProperties = exports.v1_SubscriptionPlan_SubmittedProperties = exports.v1_SubscriptionPlan_ClickedProperties = exports.v1_SubscriptionPlanRefund_ViewedProperties = exports.v1_SubscriptionPlanNextSteps_ViewedProperties = exports.v1_SubscriptionPlanDetails_ViewedProperties = exports.v1_SubscriptionPlanDetails_ClickedProperties = exports.v1_SubscriptionPlanConfirm_ViewedProperties = exports.v1_SubscriptionPaymentMethod_ViewedProperties = exports.v1_SubscriptionDetails_ViewedProperties = exports.v1_SubscriptionDetails_ClickedProperties = exports.v1_SubscriptionCancel_ClickedProperties = exports.v1_SubscriptionCancelContinue_ClickedProperties = exports.v1_SubscriptionBillingFrequency_ViewedProperties = exports.v1_SubscriptionBillingFrequency_SubmittedProperties = exports.v1_SubscriptionBillingFrequency_ClickedProperties = exports.v1_StockParty_ViewedProperties = exports.v1_StockParty_ClickedProperties = exports.v1_StockPartyClaim_ClickedProperties = exports.v1_StockBackRoundups_ViewedProperties = exports.v1_StockBackRoundups_SubmittedProperties = exports.v1_StockBackReward_ViewedProperties = exports.v1_StockBackReward_SubmittedProperties = exports.v1_StockBackHome_ViewedProperties = exports.v1_StockBackHome_ClickedProperties = exports.v1_StateZero_ViewedProperties = exports.v1_StashWorks_ClickedProperties = exports.v1_StashWorksWelcomeScreen_ViewedProperties = exports.v1_StashWorksWelcomeScreen_SubmittedProperties = exports.v1_StashWorksUserSignup_ViewedProperties = exports.v1_StashWorksUserSignup_SubmittedProperties = exports.v1_StashWorksUserSignup_ClickedProperties = exports.v1_Sso_SubmittedProperties = exports.v1_Sso_FailedProperties = exports.v1_Sso_ClickedProperties = exports.v1_SpecialOffers_ClickedProperties = exports.v1_SmartMixInfo_ClickedProperties = exports.v1_SmartDeposit_ClickedProperties = exports.v1_ShareReferral_ViewedProperties = exports.v1_SecurityDetails_ClickedProperties = exports.v1_SSN_SucceededProperties = exports.v1_SSN_SubmittedProperties = exports.v1_SSN_FailedProperties = exports.v1_SSNEntry_ViewedProperties = exports.v1_RewardsCenter_ViewedProperties = exports.v1_RewardsCenterModule_ViewedProperties = exports.v1_RewardsCenterModule_ClickedProperties = exports.v1_RetirementHome_ClickedProperties = exports.v1_RetirementDistributionForm_ClickedProperties = exports.v1_ResumeAutoStashModule_ViewedProperties = exports.v1_ResumeAutoStashModule_ClickedProperties = exports.v1_ReferralShareCode_ClickedProperties = exports.v1_ReferralModule_ViewedProperties = exports.v1_ReferralModule_ClickedProperties = exports.v1_ReferralLandingPage_ViewedProperties = exports.v1_ReferralLandingPage_ClickedProperties = exports.v1_ReferralHome_ViewedProperties = exports.v1_ReferralHome_ClickedProperties = exports.v1_RecurringTransactionAuthorization_ViewedProperties = exports.v1_RecurringTransactionAuthorization_SubmittedProperties = exports.v1_ReactivationEsig_ViewedProperties = exports.v1_ReactivationEsig_SubmittedProperties = exports.v1_ReactivationEntry_ViewedProperties = exports.v1_ReactivationEntry_SubmittedProperties = exports.v1_ReactivateSubscription_ClickedProperties = exports.v1_ProductHighlightsModule_ViewedProperties = exports.v1_ProductHighlightsModule_ClickedProperties = exports.v1_PreferredPaymentMethod_SubmittedProperties = exports.v1_PortfolioSetup_ClickedProperties = exports.v1_PortfolioSetupPrimer_ViewedProperties = exports.v1_PortfolioSetupPrimer_ClickedProperties = exports.v1_PortfolioOverview_ViewedProperties = exports.v1_PortfolioOverview_ClickedProperties = exports.v1_PortfolioDetails_ViewedProperties = exports.v1_Phone_SubmittedProperties = exports.v1_Phone_FailedProperties = exports.v1_PhoneVerification_ViewedProperties = exports.v1_PhoneOTP_SubmittedProperties = exports.v1_PhoneOTP_FailedProperties = exports.v1_PhoneOTPResend_ViewedProperties = exports.v1_PhoneOTPResend_SubmittedProperties = exports.v1_PhoneOTPResend_FailedProperties = exports.v1_PhoneOTPResend_ClickedProperties = exports.v1_PhoneEntry_ViewedProperties = exports.v1_PersonalPortfolioInfo_ClickedProperties = void 0;
exports.v1_WithdrawSetup_SucceededProperties = exports.v1_WithdrawSetup_SubmittedProperties = exports.v1_WithdrawSetup_FailedProperties = void 0;
var _enum_properties = require("../enum_properties.js");
/**
 * DO NOT MODIFY
 * This file is generated by StashInvest/product-events
 * To open an issue, go to https://github.com/StashInvest/product-events/issues/new/choose
 */

const v1_CONTEXT = exports.v1_CONTEXT = {
  protocols: {
    event_version: 1
  }
};
class v1_IdentifyProperties {
  static AccountLocked = {
    yes: 'yes',
    no: 'no'
  };
  static BankActivated = {
    yes: 'yes',
    no: 'no'
  };
  static BankCardActivate = {
    yes: 'yes',
    no: 'no'
  };
  static BankLinked = {
    yes: 'yes',
    no: 'no'
  };
  static BankPinSet = {
    yes: 'yes',
    no: 'no'
  };
  static BillingFrequency = {
    monthly: 'monthly',
    yearly: 'yearly'
  };
  static CreditdebitLinked = {
    yes: 'yes',
    no: 'no'
  };
  static DobRange = {
    below18: 'below_18',
    n18To24: '18_to_24',
    n25To34: '25_to_34',
    n35To44: '35_to_44',
    n45To54: '45_to_54',
    n55To64: '55_to_64',
    n65OrAbove: '65_or_above'
  };
  static ExternalBankLinkStatus = {
    active: 'active',
    rejected: 'rejected',
    pending: 'pending',
    needsAction: 'needs_action',
    inactive: 'inactive'
  };
  static FirstDepositDestination = {
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira',
    personalBrokerage: 'personal_brokerage',
    custodial: 'custodial',
    bank: 'bank'
  };
  static FirstDepositDestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static FraudScreenStatus = {
    approved: 'approved',
    rejected: 'rejected',
    error: 'error',
    docUpload: 'doc_upload',
    reviewPii: 'review_pii',
    manualReview: 'manual_review'
  };
  static FundedState = {
    unfunded: 'unfunded',
    funded: 'funded',
    negativeBalance: 'negative_balance'
  };
  static IsChargeable = {
    yes: 'yes',
    no: 'no'
  };
  static IsPaywalled = {
    yes: 'yes',
    no: 'no'
  };
  static IsReferred = {
    yes: 'yes',
    no: 'no'
  };
  static RoundupsActive = {
    yes: 'yes',
    no: 'no'
  };
  static SetScheduleBankActive = {
    yes: 'yes',
    no: 'no',
    tempPause: 'temp_pause'
  };
  static SetScheduleBrokerageRoboActive = {
    yes: 'yes',
    no: 'no',
    tempPause: 'temp_pause'
  };
  static SetScheduleBrokerageSelfActive = {
    yes: 'yes',
    no: 'no',
    tempPause: 'temp_pause'
  };
  static SetScheduleCustodialSelfActive = {
    yes: 'yes',
    no: 'no',
    tempPause: 'temp_pause'
  };
  static SetScheduleIraRothSelfActive = {
    yes: 'yes',
    no: 'no',
    tempPause: 'temp_pause'
  };
  static SetScheduleIraTradSelfActive = {
    yes: 'yes',
    no: 'no',
    tempPause: 'temp_pause'
  };
  static SetScheduleRetireSelfActive = {
    yes: 'yes',
    no: 'no',
    tempPause: 'temp_pause'
  };
  static SignupClickid = {
    fbclid: 'fbclid',
    gclid: 'gclid',
    irclickid: 'irclickid',
    irclid: 'irclid'
  };
  static SsoEnabled = {
    yes: 'yes',
    no: 'no'
  };
  static StashworksProspect = {
    yes: 'yes',
    no: 'no',
    tempPause: 'temp_pause'
  };
  static StatusBankAccount = {
    pending: 'pending',
    normal: 'normal',
    locked: 'locked',
    inClosingProcess: 'in_closing_process',
    closed: 'closed'
  };
  static StatusBrokerageRoboAccount = {
    incomplete: 'incomplete',
    pending: 'pending',
    rejected: 'rejected',
    errored: 'errored',
    complete: 'complete',
    inactive: 'inactive',
    locked: 'locked',
    inActivationProcess: 'in_activation_process',
    inReopenProcess: 'in_reopen_process',
    inClosingProcess: 'in_closing_process',
    closed: 'closed'
  };
  static StatusBrokerageSelfAccount = {
    incomplete: 'incomplete',
    pending: 'pending',
    rejected: 'rejected',
    errored: 'errored',
    complete: 'complete',
    inactive: 'inactive',
    locked: 'locked',
    inActivationProcess: 'in_activation_process',
    inReopenProcess: 'in_reopen_process',
    inClosingProcess: 'in_closing_process',
    closed: 'closed'
  };
  static StatusCustodialSelfAccount = {
    incomplete: 'incomplete',
    pending: 'pending',
    rejected: 'rejected',
    errored: 'errored',
    complete: 'complete',
    inactive: 'inactive',
    locked: 'locked',
    inActivationProcess: 'in_activation_process',
    inReopenProcess: 'in_reopen_process',
    inClosingProcess: 'in_closing_process',
    closed: 'closed'
  };
  static StatusIraRothSelfAccount = {
    incomplete: 'incomplete',
    pending: 'pending',
    rejected: 'rejected',
    errored: 'errored',
    complete: 'complete',
    inactive: 'inactive',
    locked: 'locked',
    inActivationProcess: 'in_activation_process',
    inReopenProcess: 'in_reopen_process',
    inClosingProcess: 'in_closing_process',
    closed: 'closed'
  };
  static StatusIraTradSelfAccount = {
    incomplete: 'incomplete',
    pending: 'pending',
    rejected: 'rejected',
    errored: 'errored',
    complete: 'complete',
    inactive: 'inactive',
    locked: 'locked',
    inActivationProcess: 'in_activation_process',
    inReopenProcess: 'in_reopen_process',
    inClosingProcess: 'in_closing_process',
    closed: 'closed'
  };
  static StockbackEnrolled = {
    yes: 'yes',
    no: 'no'
  };
  static SubscriptionRelationship = {
    prospect: 'prospect',
    chargeableSubscriber: 'chargeable_subscriber',
    freeTrialSubscriber: 'free_trial_subscriber',
    paywalledSubscriber: 'paywalled_subscriber',
    unsubscribedUser: 'unsubscribed_user'
  };
  static SubscriptionStatus = {
    created: 'created',
    active: 'active',
    offboarding: 'offboarding',
    closed: 'closed'
  };
  static SubscriptionType = {
    stashworks: 'stashworks'
  };
  static TempLegacySubscriptionActive = {
    yes: 'yes',
    no: 'no'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.account_id_brokerage_robo != null && !(typeof this.payload.account_id_brokerage_robo === 'string' || this.payload.account_id_brokerage_robo instanceof String)) {
      console.error('account_id_brokerage_robo must be of type String');
    }
    if (this.payload.account_id_brokerage_self != null && !(typeof this.payload.account_id_brokerage_self === 'string' || this.payload.account_id_brokerage_self instanceof String)) {
      console.error('account_id_brokerage_self must be of type String');
    }
    if (this.payload.account_id_custodial != null && !(typeof this.payload.account_id_custodial === 'string' || this.payload.account_id_custodial instanceof String)) {
      console.error('account_id_custodial must be of type String');
    }
    if (this.payload.account_id_roth_ira != null && !(typeof this.payload.account_id_roth_ira === 'string' || this.payload.account_id_roth_ira instanceof String)) {
      console.error('account_id_roth_ira must be of type String');
    }
    if (this.payload.account_id_traditional_ira != null && !(typeof this.payload.account_id_traditional_ira === 'string' || this.payload.account_id_traditional_ira instanceof String)) {
      console.error('account_id_traditional_ira must be of type String');
    }
    if (this.payload.account_locked != null && !Object.values(v1_IdentifyProperties.AccountLocked).includes(this.payload.account_locked)) {
      console.error('Invalid account_locked value');
    }
    if (this.payload.accountesig_at != null && !(this.payload.accountesig_at instanceof Date)) {
      console.error('accountesig_at must be of type Date');
    }
    if (this.payload.advisoryesig_at != null && !(this.payload.advisoryesig_at instanceof Date)) {
      console.error('advisoryesig_at must be of type Date');
    }
    if (this.payload.balance_bank_account != null) {
      fixedNumber = canFixNumber(this.payload.balance_bank_account);
      if (fixedNumber === false) {
        console.error('balance_bank_account must be of type Number');
      } else {
        this.payload.balance_bank_account = fixedNumber;
      }
    }
    if (this.payload.balance_brokerage_robo_account != null) {
      fixedNumber = canFixNumber(this.payload.balance_brokerage_robo_account);
      if (fixedNumber === false) {
        console.error('balance_brokerage_robo_account must be of type Number');
      } else {
        this.payload.balance_brokerage_robo_account = fixedNumber;
      }
    }
    if (this.payload.balance_brokerage_self_account != null) {
      fixedNumber = canFixNumber(this.payload.balance_brokerage_self_account);
      if (fixedNumber === false) {
        console.error('balance_brokerage_self_account must be of type Number');
      } else {
        this.payload.balance_brokerage_self_account = fixedNumber;
      }
    }
    if (this.payload.balance_custodial_self_account != null) {
      fixedNumber = canFixNumber(this.payload.balance_custodial_self_account);
      if (fixedNumber === false) {
        console.error('balance_custodial_self_account must be of type Number');
      } else {
        this.payload.balance_custodial_self_account = fixedNumber;
      }
    }
    if (this.payload.balance_ira_roth_self_account != null) {
      fixedNumber = canFixNumber(this.payload.balance_ira_roth_self_account);
      if (fixedNumber === false) {
        console.error('balance_ira_roth_self_account must be of type Number');
      } else {
        this.payload.balance_ira_roth_self_account = fixedNumber;
      }
    }
    if (this.payload.balance_ira_trad_self_account != null) {
      fixedNumber = canFixNumber(this.payload.balance_ira_trad_self_account);
      if (fixedNumber === false) {
        console.error('balance_ira_trad_self_account must be of type Number');
      } else {
        this.payload.balance_ira_trad_self_account = fixedNumber;
      }
    }
    if (this.payload.bank_activated != null && !Object.values(v1_IdentifyProperties.BankActivated).includes(this.payload.bank_activated)) {
      console.error('Invalid bank_activated value');
    }
    if (this.payload.bank_card_activate != null && !Object.values(v1_IdentifyProperties.BankCardActivate).includes(this.payload.bank_card_activate)) {
      console.error('Invalid bank_card_activate value');
    }
    if (this.payload.bank_linked != null && !Object.values(v1_IdentifyProperties.BankLinked).includes(this.payload.bank_linked)) {
      console.error('Invalid bank_linked value');
    }
    if (this.payload.bank_pin_set != null && !Object.values(v1_IdentifyProperties.BankPinSet).includes(this.payload.bank_pin_set)) {
      console.error('Invalid bank_pin_set value');
    }
    if (this.payload.billing_frequency != null && !Object.values(v1_IdentifyProperties.BillingFrequency).includes(this.payload.billing_frequency)) {
      console.error('Invalid billing_frequency value');
    }
    if (this.payload.creditdebit_expiration != null && !(typeof this.payload.creditdebit_expiration === 'string' || this.payload.creditdebit_expiration instanceof String)) {
      console.error('creditdebit_expiration must be of type String');
    }
    if (this.payload.creditdebit_linked != null && !Object.values(v1_IdentifyProperties.CreditdebitLinked).includes(this.payload.creditdebit_linked)) {
      console.error('Invalid creditdebit_linked value');
    }
    if (this.payload.dob != null && !(typeof this.payload.dob === 'string' || this.payload.dob instanceof String)) {
      console.error('dob must be of type String');
    }
    if (this.payload.dob_range != null && !Object.values(v1_IdentifyProperties.DobRange).includes(this.payload.dob_range)) {
      console.error('Invalid dob_range value');
    }
    if (this.payload.email != null && !(typeof this.payload.email === 'string' || this.payload.email instanceof String)) {
      console.error('email must be of type String');
    }
    if (this.payload.employer_name != null && !(typeof this.payload.employer_name === 'string' || this.payload.employer_name instanceof String)) {
      console.error('employer_name must be of type String');
    }
    if (this.payload.external_account_added_date != null && !(this.payload.external_account_added_date instanceof Date)) {
      console.error('external_account_added_date must be of type Date');
    }
    if (this.payload.external_bank_link_status != null && !Object.values(v1_IdentifyProperties.ExternalBankLinkStatus).includes(this.payload.external_bank_link_status)) {
      console.error('Invalid external_bank_link_status value');
    }
    if (this.payload.first_deposit_date != null && !(this.payload.first_deposit_date instanceof Date)) {
      console.error('first_deposit_date must be of type Date');
    }
    if (this.payload.first_deposit_destination != null && !Object.values(v1_IdentifyProperties.FirstDepositDestination).includes(this.payload.first_deposit_destination)) {
      console.error('Invalid first_deposit_destination value');
    }
    if (this.payload.first_deposit_destination_management_type != null && !Object.values(v1_IdentifyProperties.FirstDepositDestinationManagementType).includes(this.payload.first_deposit_destination_management_type)) {
      console.error('Invalid first_deposit_destination_management_type value');
    }
    if (this.payload.first_name != null && !(typeof this.payload.first_name === 'string' || this.payload.first_name instanceof String)) {
      console.error('first_name must be of type String');
    }
    if (this.payload.fraud_screen_approved_at != null && !(this.payload.fraud_screen_approved_at instanceof Date)) {
      console.error('fraud_screen_approved_at must be of type Date');
    }
    if (this.payload.fraud_screen_status != null && !Object.values(v1_IdentifyProperties.FraudScreenStatus).includes(this.payload.fraud_screen_status)) {
      console.error('Invalid fraud_screen_status value');
    }
    if (this.payload.free_trial_started_at != null && !(this.payload.free_trial_started_at instanceof Date)) {
      console.error('free_trial_started_at must be of type Date');
    }
    if (this.payload.funded_state != null && !Object.values(v1_IdentifyProperties.FundedState).includes(this.payload.funded_state)) {
      console.error('Invalid funded_state value');
    }
    if (this.payload.idv_status != null && !(typeof this.payload.idv_status === 'string' || this.payload.idv_status instanceof String)) {
      console.error('idv_status must be of type String');
    }
    if (this.payload.is_chargeable != null && !Object.values(v1_IdentifyProperties.IsChargeable).includes(this.payload.is_chargeable)) {
      console.error('Invalid is_chargeable value');
    }
    if (this.payload.is_paywalled != null && !Object.values(v1_IdentifyProperties.IsPaywalled).includes(this.payload.is_paywalled)) {
      console.error('Invalid is_paywalled value');
    }
    if (this.payload.is_referred != null && !Object.values(v1_IdentifyProperties.IsReferred).includes(this.payload.is_referred)) {
      console.error('Invalid is_referred value');
    }
    if (this.payload.last_bank_linked_at != null && !(this.payload.last_bank_linked_at instanceof Date)) {
      console.error('last_bank_linked_at must be of type Date');
    }
    if (this.payload.last_creditdebit_linked_at != null && !(this.payload.last_creditdebit_linked_at instanceof Date)) {
      console.error('last_creditdebit_linked_at must be of type Date');
    }
    if (this.payload.last_name != null && !(typeof this.payload.last_name === 'string' || this.payload.last_name instanceof String)) {
      console.error('last_name must be of type String');
    }
    if (this.payload.phone != null && !(typeof this.payload.phone === 'string' || this.payload.phone instanceof String)) {
      console.error('phone must be of type String');
    }
    if (this.payload.roundups_active != null && !Object.values(v1_IdentifyProperties.RoundupsActive).includes(this.payload.roundups_active)) {
      console.error('Invalid roundups_active value');
    }
    if (this.payload.set_schedule_bank_active != null && !Object.values(v1_IdentifyProperties.SetScheduleBankActive).includes(this.payload.set_schedule_bank_active)) {
      console.error('Invalid set_schedule_bank_active value');
    }
    if (this.payload.set_schedule_brokerage_robo_active != null && !Object.values(v1_IdentifyProperties.SetScheduleBrokerageRoboActive).includes(this.payload.set_schedule_brokerage_robo_active)) {
      console.error('Invalid set_schedule_brokerage_robo_active value');
    }
    if (this.payload.set_schedule_brokerage_self_active != null && !Object.values(v1_IdentifyProperties.SetScheduleBrokerageSelfActive).includes(this.payload.set_schedule_brokerage_self_active)) {
      console.error('Invalid set_schedule_brokerage_self_active value');
    }
    if (this.payload.set_schedule_custodial_self_active != null && !Object.values(v1_IdentifyProperties.SetScheduleCustodialSelfActive).includes(this.payload.set_schedule_custodial_self_active)) {
      console.error('Invalid set_schedule_custodial_self_active value');
    }
    if (this.payload.set_schedule_ira_roth_self_active != null && !Object.values(v1_IdentifyProperties.SetScheduleIraRothSelfActive).includes(this.payload.set_schedule_ira_roth_self_active)) {
      console.error('Invalid set_schedule_ira_roth_self_active value');
    }
    if (this.payload.set_schedule_ira_trad_self_active != null && !Object.values(v1_IdentifyProperties.SetScheduleIraTradSelfActive).includes(this.payload.set_schedule_ira_trad_self_active)) {
      console.error('Invalid set_schedule_ira_trad_self_active value');
    }
    if (this.payload.set_schedule_retire_self_active != null && !Object.values(v1_IdentifyProperties.SetScheduleRetireSelfActive).includes(this.payload.set_schedule_retire_self_active)) {
      console.error('Invalid set_schedule_retire_self_active value');
    }
    if (this.payload.signup_clickid != null && !Object.values(v1_IdentifyProperties.SignupClickid).includes(this.payload.signup_clickid)) {
      console.error('Invalid signup_clickid value');
    }
    if (this.payload.sso_enabled != null && !Object.values(v1_IdentifyProperties.SsoEnabled).includes(this.payload.sso_enabled)) {
      console.error('Invalid sso_enabled value');
    }
    if (this.payload.stashworks_prospect != null && !Object.values(v1_IdentifyProperties.StashworksProspect).includes(this.payload.stashworks_prospect)) {
      console.error('Invalid stashworks_prospect value');
    }
    if (this.payload.status_bank_account != null && !Object.values(v1_IdentifyProperties.StatusBankAccount).includes(this.payload.status_bank_account)) {
      console.error('Invalid status_bank_account value');
    }
    if (this.payload.status_brokerage_robo_account != null && !Object.values(v1_IdentifyProperties.StatusBrokerageRoboAccount).includes(this.payload.status_brokerage_robo_account)) {
      console.error('Invalid status_brokerage_robo_account value');
    }
    if (this.payload.status_brokerage_self_account != null && !Object.values(v1_IdentifyProperties.StatusBrokerageSelfAccount).includes(this.payload.status_brokerage_self_account)) {
      console.error('Invalid status_brokerage_self_account value');
    }
    if (this.payload.status_custodial_self_account != null && !Object.values(v1_IdentifyProperties.StatusCustodialSelfAccount).includes(this.payload.status_custodial_self_account)) {
      console.error('Invalid status_custodial_self_account value');
    }
    if (this.payload.status_ira_roth_self_account != null && !Object.values(v1_IdentifyProperties.StatusIraRothSelfAccount).includes(this.payload.status_ira_roth_self_account)) {
      console.error('Invalid status_ira_roth_self_account value');
    }
    if (this.payload.status_ira_trad_self_account != null && !Object.values(v1_IdentifyProperties.StatusIraTradSelfAccount).includes(this.payload.status_ira_trad_self_account)) {
      console.error('Invalid status_ira_trad_self_account value');
    }
    if (this.payload.stockback_enrolled != null && !Object.values(v1_IdentifyProperties.StockbackEnrolled).includes(this.payload.stockback_enrolled)) {
      console.error('Invalid stockback_enrolled value');
    }
    if (this.payload.subscription_relationship != null && !Object.values(v1_IdentifyProperties.SubscriptionRelationship).includes(this.payload.subscription_relationship)) {
      console.error('Invalid subscription_relationship value');
    }
    if (this.payload.subscription_status != null && !Object.values(v1_IdentifyProperties.SubscriptionStatus).includes(this.payload.subscription_status)) {
      console.error('Invalid subscription_status value');
    }
    if (this.payload.subscription_type != null && !Object.values(v1_IdentifyProperties.SubscriptionType).includes(this.payload.subscription_type)) {
      console.error('Invalid subscription_type value');
    }
    if (this.payload.temp_legacy_subscription_active != null && !Object.values(v1_IdentifyProperties.TempLegacySubscriptionActive).includes(this.payload.temp_legacy_subscription_active)) {
      console.error('Invalid temp_legacy_subscription_active value');
    }
    if (this.payload.tier_bundle != null && !(typeof this.payload.tier_bundle === 'string' || this.payload.tier_bundle instanceof String)) {
      console.error('tier_bundle must be of type String');
    }
    if (this.payload.tier_plan != null && !(typeof this.payload.tier_plan === 'string' || this.payload.tier_plan instanceof String)) {
      console.error('tier_plan must be of type String');
    }
    if (this.payload.tier_type != null && !(typeof this.payload.tier_type === 'string' || this.payload.tier_type instanceof String)) {
      console.error('tier_type must be of type String');
    }
    if (this.payload.user_creation_date != null && !(this.payload.user_creation_date instanceof Date)) {
      console.error('user_creation_date must be of type Date');
    }
    if (this.payload.user_id != null && !(typeof this.payload.user_id === 'string' || this.payload.user_id instanceof String)) {
      console.error('user_id must be of type String');
    }
    if (this.payload.user_unique_id != null && !(typeof this.payload.user_unique_id === 'string' || this.payload.user_unique_id instanceof String)) {
      console.error('user_unique_id must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['account_id_brokerage_robo', 'account_id_brokerage_self', 'account_id_custodial', 'account_id_roth_ira', 'account_id_traditional_ira', 'account_locked', 'accountesig_at', 'advisoryesig_at', 'balance_bank_account', 'balance_brokerage_robo_account', 'balance_brokerage_self_account', 'balance_custodial_self_account', 'balance_ira_roth_self_account', 'balance_ira_trad_self_account', 'bank_activated', 'bank_card_activate', 'bank_linked', 'bank_pin_set', 'billing_frequency', 'creditdebit_expiration', 'creditdebit_linked', 'dob', 'dob_range', 'email', 'employer_name', 'external_account_added_date', 'external_bank_link_status', 'first_deposit_date', 'first_deposit_destination', 'first_deposit_destination_management_type', 'first_name', 'fraud_screen_approved_at', 'fraud_screen_status', 'free_trial_started_at', 'funded_state', 'idv_status', 'is_chargeable', 'is_paywalled', 'is_referred', 'last_bank_linked_at', 'last_creditdebit_linked_at', 'last_name', 'phone', 'roundups_active', 'set_schedule_bank_active', 'set_schedule_brokerage_robo_active', 'set_schedule_brokerage_self_active', 'set_schedule_custodial_self_active', 'set_schedule_ira_roth_self_active', 'set_schedule_ira_trad_self_active', 'set_schedule_retire_self_active', 'signup_clickid', 'sso_enabled', 'stashworks_prospect', 'status_bank_account', 'status_brokerage_robo_account', 'status_brokerage_self_account', 'status_custodial_self_account', 'status_ira_roth_self_account', 'status_ira_trad_self_account', 'stockback_enrolled', 'subscription_relationship', 'subscription_status', 'subscription_type', 'temp_legacy_subscription_active', 'tier_bundle', 'tier_plan', 'tier_type', 'user_creation_date', 'user_id', 'user_unique_id']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_IdentifyProperties = v1_IdentifyProperties;
class v1_AccountAgreement_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AccountAgreement_SubmittedProperties = v1_AccountAgreement_SubmittedProperties;
class v1_AccountAgreement_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AccountAgreement_ViewedProperties = v1_AccountAgreement_ViewedProperties;
class v1_AccountDetails_ClickedProperties {
  static AccountBehavior = {
    customerDirected: 'customer_directed',
    smart: 'smart'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['account_behavior', 'account_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_AccountDetails_ClickedProperties.AccountBehavior).includes(this.payload.account_behavior)) {
      console.error('Invalid account_behavior value');
    }
    if (!Object.values(_enum_properties.AccountType).includes(this.payload.account_type)) {
      console.error('Invalid account_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['account_behavior', 'account_type', 'flow_type', 'origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AccountDetails_ClickedProperties = v1_AccountDetails_ClickedProperties;
class v1_AccountOpen_ClickedProperties {
  static AccountBehavior = {
    smart: 'smart',
    customerDirected: 'customer_directed'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['account_behavior', 'account_type', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(v1_AccountOpen_ClickedProperties.AccountBehavior).includes(this.payload.account_behavior)) {
      console.error('Invalid account_behavior value');
    }
    if (!Object.values(_enum_properties.AccountType).includes(this.payload.account_type)) {
      console.error('Invalid account_type value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['account_behavior', 'account_type', 'screen', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AccountOpen_ClickedProperties = v1_AccountOpen_ClickedProperties;
class v1_AccountSetup_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['management_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.ManagementType).includes(this.payload.management_type)) {
      console.error('Invalid management_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.account_type != null && !Object.values(_enum_properties.AccountType).includes(this.payload.account_type)) {
      console.error('Invalid account_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.investment_type != null && !Object.values(_enum_properties.InvestmentType).includes(this.payload.investment_type)) {
      console.error('Invalid investment_type value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['management_type', 'origin', 'account_type', 'flow_type', 'investment_type', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AccountSetup_ClickedProperties = v1_AccountSetup_ClickedProperties;
class v1_AddAccount_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AddAccount_ClickedProperties = v1_AddAccount_ClickedProperties;
class v1_AddAccount_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AddAccount_ViewedProperties = v1_AddAccount_ViewedProperties;
class v1_AddressEntry_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AddressEntry_ViewedProperties = v1_AddressEntry_ViewedProperties;
class v1_Address_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Address_SubmittedProperties = v1_Address_SubmittedProperties;
class v1_Address_SucceededProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Address_SucceededProperties = v1_Address_SucceededProperties;
class v1_AdvisoryEsig_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AdvisoryEsig_SubmittedProperties = v1_AdvisoryEsig_SubmittedProperties;
class v1_AdvisoryEsig_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AdvisoryEsig_ViewedProperties = v1_AdvisoryEsig_ViewedProperties;
class v1_AiChatAgentLink_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.action_link != null && !(typeof this.payload.action_link === 'string' || this.payload.action_link instanceof String)) {
      console.error('action_link must be of type String');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'action_link', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AiChatAgentLink_ClickedProperties = v1_AiChatAgentLink_ClickedProperties;
class v1_AiChatCTA_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AiChatCTA_ClickedProperties = v1_AiChatCTA_ClickedProperties;
class v1_AiChatDisclosureLink_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.action_link != null && !(typeof this.payload.action_link === 'string' || this.payload.action_link instanceof String)) {
      console.error('action_link must be of type String');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'action_link', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AiChatDisclosureLink_ClickedProperties = v1_AiChatDisclosureLink_ClickedProperties;
class v1_AiChatEntryPoint_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.concept != null && !(typeof this.payload.concept === 'string' || this.payload.concept instanceof String)) {
      console.error('concept must be of type String');
    }
    if (this.payload.container_type != null && !(typeof this.payload.container_type === 'string' || this.payload.container_type instanceof String)) {
      console.error('container_type must be of type String');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.focus != null && !(typeof this.payload.focus === 'string' || this.payload.focus instanceof String)) {
      console.error('focus must be of type String');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.task_id != null && !(typeof this.payload.task_id === 'string' || this.payload.task_id instanceof String)) {
      console.error('task_id must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'concept', 'container_type', 'flow_type', 'focus', 'screen', 'task_id']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AiChatEntryPoint_ClickedProperties = v1_AiChatEntryPoint_ClickedProperties;
class v1_AiChatFlag_ProcessedProperties {
  static AbTestEnabled = {
    yes: 'yes',
    no: 'no'
  };
  static Variation = {
    enabled: 'enabled',
    disabled: 'disabled',
    holdout: 'holdout'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['ab_test_enabled', 'origin', 'variation']);
    var fixedNumber = 0;
    if (!Object.values(v1_AiChatFlag_ProcessedProperties.AbTestEnabled).includes(this.payload.ab_test_enabled)) {
      console.error('Invalid ab_test_enabled value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_AiChatFlag_ProcessedProperties.Variation).includes(this.payload.variation)) {
      console.error('Invalid variation value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['ab_test_enabled', 'origin', 'variation', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AiChatFlag_ProcessedProperties = v1_AiChatFlag_ProcessedProperties;
class v1_AiChatSuggestedTopic_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.topic != null && !(typeof this.payload.topic === 'string' || this.payload.topic instanceof String)) {
      console.error('topic must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen', 'topic']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AiChatSuggestedTopic_ClickedProperties = v1_AiChatSuggestedTopic_ClickedProperties;
class v1_AiChat_ClosedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AiChat_ClosedProperties = v1_AiChat_ClosedProperties;
class v1_AiChat_FailedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.error != null && !(typeof this.payload.error === 'string' || this.payload.error instanceof String)) {
      console.error('error must be of type String');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'error', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AiChat_FailedProperties = v1_AiChat_FailedProperties;
class v1_AiChat_SubmittedProperties {
  static IsTopic = {
    yes: 'yes',
    no: 'no'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['is_topic', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(v1_AiChat_SubmittedProperties.IsTopic).includes(this.payload.is_topic)) {
      console.error('Invalid is_topic value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.fbclid != null && !(typeof this.payload.fbclid === 'string' || this.payload.fbclid instanceof String)) {
      console.error('fbclid must be of type String');
    }
    if (this.payload.gclid != null && !(typeof this.payload.gclid === 'string' || this.payload.gclid instanceof String)) {
      console.error('gclid must be of type String');
    }
    if (this.payload.irclickid != null && !(typeof this.payload.irclickid === 'string' || this.payload.irclickid instanceof String)) {
      console.error('irclickid must be of type String');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['is_topic', 'origin', 'fbclid', 'gclid', 'irclickid', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AiChat_SubmittedProperties = v1_AiChat_SubmittedProperties;
class v1_AiChat_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AiChat_ViewedProperties = v1_AiChat_ViewedProperties;
class v1_AppSession_StartedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.ad != null && !(typeof this.payload.ad === 'string' || this.payload.ad instanceof String)) {
      console.error('ad must be of type String');
    }
    if (this.payload.ad_id != null && !(typeof this.payload.ad_id === 'string' || this.payload.ad_id instanceof String)) {
      console.error('ad_id must be of type String');
    }
    if (this.payload.ad_type != null && !(typeof this.payload.ad_type === 'string' || this.payload.ad_type instanceof String)) {
      console.error('ad_type must be of type String');
    }
    if (this.payload.campaign != null && !(typeof this.payload.campaign === 'string' || this.payload.campaign instanceof String)) {
      console.error('campaign must be of type String');
    }
    if (this.payload.campaign_id != null && !(typeof this.payload.campaign_id === 'string' || this.payload.campaign_id instanceof String)) {
      console.error('campaign_id must be of type String');
    }
    if (this.payload.channel != null && !(typeof this.payload.channel === 'string' || this.payload.channel instanceof String)) {
      console.error('channel must be of type String');
    }
    if (this.payload.click_id != null && !(typeof this.payload.click_id === 'string' || this.payload.click_id instanceof String)) {
      console.error('click_id must be of type String');
    }
    if (this.payload.is_retargeting != null && !(typeof this.payload.is_retargeting === 'string' || this.payload.is_retargeting instanceof String)) {
      console.error('is_retargeting must be of type String');
    }
    if (this.payload.keywords != null && !(typeof this.payload.keywords === 'string' || this.payload.keywords instanceof String)) {
      console.error('keywords must be of type String');
    }
    if (this.payload.media_source != null && !(typeof this.payload.media_source === 'string' || this.payload.media_source instanceof String)) {
      console.error('media_source must be of type String');
    }
    if (this.payload.partner != null && !(typeof this.payload.partner === 'string' || this.payload.partner instanceof String)) {
      console.error('partner must be of type String');
    }
    if (this.payload.site_id != null && !(typeof this.payload.site_id === 'string' || this.payload.site_id instanceof String)) {
      console.error('site_id must be of type String');
    }
    if (this.payload.sub_site_id != null && !(typeof this.payload.sub_site_id === 'string' || this.payload.sub_site_id instanceof String)) {
      console.error('sub_site_id must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['ad', 'ad_id', 'ad_type', 'campaign', 'campaign_id', 'channel', 'click_id', 'is_retargeting', 'keywords', 'media_source', 'partner', 'site_id', 'sub_site_id']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AppSession_StartedProperties = v1_AppSession_StartedProperties;
class v1_AutoStashDetails_ClickedProperties {
  static AccountBehavior = {
    customerDirected: 'customer_directed',
    smart: 'smart'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['account_behavior', 'account_type', 'flow_type', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(v1_AutoStashDetails_ClickedProperties.AccountBehavior).includes(this.payload.account_behavior)) {
      console.error('Invalid account_behavior value');
    }
    if (!Object.values(_enum_properties.AccountType).includes(this.payload.account_type)) {
      console.error('Invalid account_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['account_behavior', 'account_type', 'flow_type', 'origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashDetails_ClickedProperties = v1_AutoStashDetails_ClickedProperties;
class v1_AutoStashDetails_ViewedProperties {
  static Destination = {
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    personalBrokerage: 'personal_brokerage',
    custodial: 'custodial'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static SetScheduleStatus = {
    enabled: 'enabled',
    paused: 'paused',
    disabled: 'disabled'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['destination', 'destination_management_type', 'origin', 'set_schedule_status']);
    var fixedNumber = 0;
    if (!Object.values(v1_AutoStashDetails_ViewedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashDetails_ViewedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_AutoStashDetails_ViewedProperties.SetScheduleStatus).includes(this.payload.set_schedule_status)) {
      console.error('Invalid set_schedule_status value');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashDetails_ViewedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['destination', 'destination_management_type', 'origin', 'set_schedule_status', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashDetails_ViewedProperties = v1_AutoStashDetails_ViewedProperties;
class v1_AutoStashDisableContinue_ClickedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Variation = {
    changeAmount: 'change_amount',
    changeFrequency: 'change_frequency',
    changeBoth: 'change_both'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['change_type', 'destination', 'destination_management_type', 'flow_type', 'origin', 'screen', 'variation']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.ChangeType).includes(this.payload.change_type)) {
      console.error('Invalid change_type value');
    }
    if (!Object.values(v1_AutoStashDisableContinue_ClickedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashDisableContinue_ClickedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (!Object.values(v1_AutoStashDisableContinue_ClickedProperties.Variation).includes(this.payload.variation)) {
      console.error('Invalid variation value');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashDisableContinue_ClickedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['change_type', 'destination', 'destination_management_type', 'flow_type', 'origin', 'screen', 'variation', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashDisableContinue_ClickedProperties = v1_AutoStashDisableContinue_ClickedProperties;
class v1_AutoStashDisableSpeedbump_ViewedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Variation = {
    changeAmount: 'change_amount',
    changeFrequency: 'change_frequency',
    changeBoth: 'change_both'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['change_type', 'destination', 'destination_management_type', 'flow_type', 'origin', 'variation']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.ChangeType).includes(this.payload.change_type)) {
      console.error('Invalid change_type value');
    }
    if (!Object.values(v1_AutoStashDisableSpeedbump_ViewedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashDisableSpeedbump_ViewedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_AutoStashDisableSpeedbump_ViewedProperties.Variation).includes(this.payload.variation)) {
      console.error('Invalid variation value');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashDisableSpeedbump_ViewedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['change_type', 'destination', 'destination_management_type', 'flow_type', 'origin', 'variation', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashDisableSpeedbump_ViewedProperties = v1_AutoStashDisableSpeedbump_ViewedProperties;
class v1_AutoStashHome_ClickedProperties {
  static Results = {
    success: 'success'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.results != null && !Object.values(v1_AutoStashHome_ClickedProperties.Results).includes(this.payload.results)) {
      console.error('Invalid results value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'flow_type', 'results', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashHome_ClickedProperties = v1_AutoStashHome_ClickedProperties;
class v1_AutoStashModifyResult_ViewedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Result = {
    succeeded: 'succeeded',
    error: 'error'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'modification', 'origin', 'result']);
    var fixedNumber = 0;
    if (!Object.values(v1_AutoStashModifyResult_ViewedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashModifyResult_ViewedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Modification).includes(this.payload.modification)) {
      console.error('Invalid modification value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_AutoStashModifyResult_ViewedProperties.Result).includes(this.payload.result)) {
      console.error('Invalid result value');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashModifyResult_ViewedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'modification', 'origin', 'result', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashModifyResult_ViewedProperties = v1_AutoStashModifyResult_ViewedProperties;
class v1_AutoStashModify_ClickedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'modification', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(v1_AutoStashModify_ClickedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashModify_ClickedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Modification).includes(this.payload.modification)) {
      console.error('Invalid modification value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashModify_ClickedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'modification', 'origin', 'screen', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashModify_ClickedProperties = v1_AutoStashModify_ClickedProperties;
class v1_AutoStashModify_FailedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'modification', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(v1_AutoStashModify_FailedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashModify_FailedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Modification).includes(this.payload.modification)) {
      console.error('Invalid modification value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashModify_FailedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'modification', 'origin', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashModify_FailedProperties = v1_AutoStashModify_FailedProperties;
class v1_AutoStashModify_SubmittedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'modification', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(v1_AutoStashModify_SubmittedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashModify_SubmittedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Modification).includes(this.payload.modification)) {
      console.error('Invalid modification value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashModify_SubmittedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'modification', 'origin', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashModify_SubmittedProperties = v1_AutoStashModify_SubmittedProperties;
class v1_AutoStashModify_SucceededProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'modification', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(v1_AutoStashModify_SucceededProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashModify_SucceededProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Modification).includes(this.payload.modification)) {
      console.error('Invalid modification value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashModify_SucceededProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'modification', 'origin', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashModify_SucceededProperties = v1_AutoStashModify_SucceededProperties;
class v1_AutoStashModify_ViewedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'modification', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(v1_AutoStashModify_ViewedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashModify_ViewedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Modification).includes(this.payload.modification)) {
      console.error('Invalid modification value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashModify_ViewedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'modification', 'origin', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashModify_ViewedProperties = v1_AutoStashModify_ViewedProperties;
class v1_AutoStashModule_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.learn_id != null && !(typeof this.payload.learn_id === 'string' || this.payload.learn_id instanceof String)) {
      console.error('learn_id must be of type String');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
    if (this.payload.title != null && !(typeof this.payload.title === 'string' || this.payload.title instanceof String)) {
      console.error('title must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'screen', 'learn_id', 'security_ticker', 'ticker_symbol', 'title']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashModule_ClickedProperties = v1_AutoStashModule_ClickedProperties;
class v1_AutoStashModule_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'screen', 'security_ticker', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashModule_ViewedProperties = v1_AutoStashModule_ViewedProperties;
class v1_AutoStashPauseSetup_FailedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'origin', 'resume_date']);
    var fixedNumber = 0;
    if (!Object.values(v1_AutoStashPauseSetup_FailedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashPauseSetup_FailedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!(typeof this.payload.resume_date === 'string' || this.payload.resume_date instanceof String)) {
      console.error('resume_date must be of type String');
    }
    if (this.payload.error_code != null && !(typeof this.payload.error_code === 'string' || this.payload.error_code instanceof String)) {
      console.error('error_code must be of type String');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashPauseSetup_FailedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'origin', 'resume_date', 'error_code', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashPauseSetup_FailedProperties = v1_AutoStashPauseSetup_FailedProperties;
class v1_AutoStashPauseSetup_SubmittedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'origin', 'resume_date']);
    var fixedNumber = 0;
    if (!Object.values(v1_AutoStashPauseSetup_SubmittedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashPauseSetup_SubmittedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!(typeof this.payload.resume_date === 'string' || this.payload.resume_date instanceof String)) {
      console.error('resume_date must be of type String');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashPauseSetup_SubmittedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'origin', 'resume_date', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashPauseSetup_SubmittedProperties = v1_AutoStashPauseSetup_SubmittedProperties;
class v1_AutoStashPauseSetup_SucceededProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'origin', 'resume_date']);
    var fixedNumber = 0;
    if (!Object.values(v1_AutoStashPauseSetup_SucceededProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashPauseSetup_SucceededProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!(typeof this.payload.resume_date === 'string' || this.payload.resume_date instanceof String)) {
      console.error('resume_date must be of type String');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashPauseSetup_SucceededProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'origin', 'resume_date', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashPauseSetup_SucceededProperties = v1_AutoStashPauseSetup_SucceededProperties;
class v1_AutoStashPauseSetup_ViewedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(v1_AutoStashPauseSetup_ViewedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashPauseSetup_ViewedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashPauseSetup_ViewedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'origin', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashPauseSetup_ViewedProperties = v1_AutoStashPauseSetup_ViewedProperties;
class v1_AutoStashPause_ClickedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(v1_AutoStashPause_ClickedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashPause_ClickedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashPause_ClickedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'origin', 'screen', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashPause_ClickedProperties = v1_AutoStashPause_ClickedProperties;
class v1_AutoStashProjection_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashProjection_ClickedProperties = v1_AutoStashProjection_ClickedProperties;
class v1_AutoStashProjection_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashProjection_ViewedProperties = v1_AutoStashProjection_ViewedProperties;
class v1_AutoStashRemoveAllocation_ClickedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage'
  };
  static DestinationManagementType = {
    selfDirected: 'self_directed',
    robo: 'robo'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'frequency_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(v1_AutoStashRemoveAllocation_ClickedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashRemoveAllocation_ClickedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashRemoveAllocation_ClickedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'frequency_type', 'origin', 'security_ticker', 'source', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashRemoveAllocation_ClickedProperties = v1_AutoStashRemoveAllocation_ClickedProperties;
class v1_AutoStashResumeConfirmation_ViewedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial'
  };
  static DestinationManagementType = {
    selfDirected: 'self_directed',
    robo: 'robo'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'destination', 'destination_management_type', 'flow_type', 'origin']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!Object.values(v1_AutoStashResumeConfirmation_ViewedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashResumeConfirmation_ViewedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.frequency_type != null && !Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashResumeConfirmation_ViewedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'destination', 'destination_management_type', 'flow_type', 'origin', 'frequency_schedule', 'frequency_type', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashResumeConfirmation_ViewedProperties = v1_AutoStashResumeConfirmation_ViewedProperties;
class v1_AutoStashResume_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['account_type', 'management_type', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.AccountType).includes(this.payload.account_type)) {
      console.error('Invalid account_type value');
    }
    if (!Object.values(_enum_properties.ManagementType).includes(this.payload.management_type)) {
      console.error('Invalid management_type value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['account_type', 'management_type', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashResume_ClickedProperties = v1_AutoStashResume_ClickedProperties;
class v1_AutoStashResume_SubmittedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial'
  };
  static DestinationManagementType = {
    selfDirected: 'self_directed',
    robo: 'robo'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'destination', 'destination_management_type', 'flow_type', 'origin']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!Object.values(v1_AutoStashResume_SubmittedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_AutoStashResume_SubmittedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.frequency_type != null && !Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.source != null && !Object.values(v1_AutoStashResume_SubmittedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'destination', 'destination_management_type', 'flow_type', 'origin', 'frequency_schedule', 'frequency_type', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_AutoStashResume_SubmittedProperties = v1_AutoStashResume_SubmittedProperties;
class v1_BrowseInvestments_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.account_type != null && !Object.values(_enum_properties.AccountType).includes(this.payload.account_type)) {
      console.error('Invalid account_type value');
    }
    if (this.payload.management_type != null && !Object.values(_enum_properties.ManagementType).includes(this.payload.management_type)) {
      console.error('Invalid management_type value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'account_type', 'management_type', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_BrowseInvestments_ClickedProperties = v1_BrowseInvestments_ClickedProperties;
class v1_BrowseInvestments_ViewedProperties {
  static RoboSetupCard = {
    yes: 'yes',
    no: 'no'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['investment_type', 'robo_setup_card']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.InvestmentType).includes(this.payload.investment_type)) {
      console.error('Invalid investment_type value');
    }
    if (!Object.values(v1_BrowseInvestments_ViewedProperties.RoboSetupCard).includes(this.payload.robo_setup_card)) {
      console.error('Invalid robo_setup_card value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['investment_type', 'robo_setup_card', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_BrowseInvestments_ViewedProperties = v1_BrowseInvestments_ViewedProperties;
class v1_BuyAmountEntry_ViewedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['destination', 'destination_management_type', 'frequency_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_BuyAmountEntry_ViewedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_BuyAmountEntry_ViewedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['destination', 'destination_management_type', 'frequency_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_BuyAmountEntry_ViewedProperties = v1_BuyAmountEntry_ViewedProperties;
class v1_BuyConfirmation_ViewedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'frequency_type']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_BuyConfirmation_ViewedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_BuyConfirmation_ViewedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.source != null && !Object.values(v1_BuyConfirmation_ViewedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'frequency_type', 'flow_type', 'frequency_schedule', 'origin', 'security_ticker', 'source', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_BuyConfirmation_ViewedProperties = v1_BuyConfirmation_ViewedProperties;
class v1_BuyOptions_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['frequency_type', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['frequency_type', 'screen', 'flow_type', 'origin', 'security_ticker', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_BuyOptions_ClickedProperties = v1_BuyOptions_ClickedProperties;
class v1_BuyOptions_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['screen', 'flow_type', 'origin', 'security_ticker', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_BuyOptions_ViewedProperties = v1_BuyOptions_ViewedProperties;
class v1_BuySetupResults_ViewedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Result = {
    succeeded: 'succeeded',
    error: 'error'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank',
    portfolioCash: 'portfolio_cash'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'flow_type', 'origin', 'result', 'source']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_BuySetupResults_ViewedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_BuySetupResults_ViewedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_BuySetupResults_ViewedProperties.Result).includes(this.payload.result)) {
      console.error('Invalid result value');
    }
    if (!Object.values(v1_BuySetupResults_ViewedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.frequency_type != null && !Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'flow_type', 'origin', 'result', 'source', 'frequency_schedule', 'frequency_type', 'security_ticker', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_BuySetupResults_ViewedProperties = v1_BuySetupResults_ViewedProperties;
class v1_BuySetup_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_BuySetup_ClickedProperties = v1_BuySetup_ClickedProperties;
class v1_BuySetup_FailedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank',
    portfolioCash: 'portfolio_cash'
  };
  static ErrorType = {
    apiError: 'api_error'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'flow_type', 'origin', 'source']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_BuySetup_FailedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_BuySetup_FailedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_BuySetup_FailedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (this.payload.error_code != null && !(typeof this.payload.error_code === 'string' || this.payload.error_code instanceof String)) {
      console.error('error_code must be of type String');
    }
    if (this.payload.error_type != null && !Object.values(v1_BuySetup_FailedProperties.ErrorType).includes(this.payload.error_type)) {
      console.error('Invalid error_type value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.frequency_type != null && !Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'flow_type', 'origin', 'source', 'error_code', 'error_type', 'frequency_schedule', 'frequency_type', 'security_ticker', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_BuySetup_FailedProperties = v1_BuySetup_FailedProperties;
class v1_BuySetup_SubmittedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank',
    portfolioCash: 'portfolio_cash'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'flow_type', 'origin', 'source']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_BuySetup_SubmittedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_BuySetup_SubmittedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_BuySetup_SubmittedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.frequency_type != null && !Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'flow_type', 'origin', 'source', 'frequency_schedule', 'frequency_type', 'screen', 'security_ticker', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_BuySetup_SubmittedProperties = v1_BuySetup_SubmittedProperties;
class v1_BuySetup_SucceededProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank',
    portfolioCash: 'portfolio_cash'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'flow_type', 'origin', 'source']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_BuySetup_SucceededProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_BuySetup_SucceededProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_BuySetup_SucceededProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (this.payload.fbclid != null && !(typeof this.payload.fbclid === 'string' || this.payload.fbclid instanceof String)) {
      console.error('fbclid must be of type String');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.frequency_type != null && !Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.gclid != null && !(typeof this.payload.gclid === 'string' || this.payload.gclid instanceof String)) {
      console.error('gclid must be of type String');
    }
    if (this.payload.irclickid != null && !(typeof this.payload.irclickid === 'string' || this.payload.irclickid instanceof String)) {
      console.error('irclickid must be of type String');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'flow_type', 'origin', 'source', 'fbclid', 'frequency_schedule', 'frequency_type', 'gclid', 'irclickid', 'security_ticker', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_BuySetup_SucceededProperties = v1_BuySetup_SucceededProperties;
class v1_BuySetup_ViewedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    externalBank: 'external_bank',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.destination != null && !Object.values(v1_BuySetup_ViewedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (this.payload.destination_management_type != null && !Object.values(v1_BuySetup_ViewedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.frequency_type != null && !Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.source != null && !Object.values(v1_BuySetup_ViewedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'frequency_schedule', 'frequency_type', 'origin', 'security_ticker', 'source', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_BuySetup_ViewedProperties = v1_BuySetup_ViewedProperties;
class v1_BuySucceeded_ViewedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'frequency_type']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_BuySucceeded_ViewedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_BuySucceeded_ViewedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'frequency_type', 'frequency_schedule', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_BuySucceeded_ViewedProperties = v1_BuySucceeded_ViewedProperties;
class v1_Buy_FailedProperties {
  static ErrorType = {
    apiError: 'api_error'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['error_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_Buy_FailedProperties.ErrorType).includes(this.payload.error_type)) {
      console.error('Invalid error_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['error_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Buy_FailedProperties = v1_Buy_FailedProperties;
class v1_Buy_SubmittedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira',
    custodial: 'custodial'
  };
  static DestinationManagementType = {
    selfDirected: 'self_directed',
    robo: 'robo'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'frequency_type']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_Buy_SubmittedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_Buy_SubmittedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'frequency_type', 'frequency_schedule', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Buy_SubmittedProperties = v1_Buy_SubmittedProperties;
class v1_Buy_SucceededProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira',
    custodial: 'custodial'
  };
  static DestinationManagementType = {
    selfDirected: 'self_directed',
    robo: 'robo'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'frequency_type']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_Buy_SucceededProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_Buy_SucceededProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'frequency_type', 'frequency_schedule', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Buy_SucceededProperties = v1_Buy_SucceededProperties;
class v1_CancelSubscriptionResults_ViewedProperties {
  static Result = {
    failure: 'failure',
    success: 'success'
  };
  static ErrorType = {
    apiError: 'api_error'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['result']);
    var fixedNumber = 0;
    if (!Object.values(v1_CancelSubscriptionResults_ViewedProperties.Result).includes(this.payload.result)) {
      console.error('Invalid result value');
    }
    if (this.payload.error_code != null && !(typeof this.payload.error_code === 'string' || this.payload.error_code instanceof String)) {
      console.error('error_code must be of type String');
    }
    if (this.payload.error_type != null && !Object.values(v1_CancelSubscriptionResults_ViewedProperties.ErrorType).includes(this.payload.error_type)) {
      console.error('Invalid error_type value');
    }
    if (this.payload.reason != null && !(typeof this.payload.reason === 'string' || this.payload.reason instanceof String)) {
      console.error('reason must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['result', 'error_code', 'error_type', 'reason']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_CancelSubscriptionResults_ViewedProperties = v1_CancelSubscriptionResults_ViewedProperties;
class v1_Category_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['category_name', 'investment_type', 'screen']);
    var fixedNumber = 0;
    if (!(typeof this.payload.category_name === 'string' || this.payload.category_name instanceof String)) {
      console.error('category_name must be of type String');
    }
    if (!Object.values(_enum_properties.InvestmentType).includes(this.payload.investment_type)) {
      console.error('Invalid investment_type value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['category_name', 'investment_type', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Category_ClickedProperties = v1_Category_ClickedProperties;
class v1_ChooseDocument_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ChooseDocument_ViewedProperties = v1_ChooseDocument_ViewedProperties;
class v1_CoachFeedEntryPoint_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'flow_type', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_CoachFeedEntryPoint_ClickedProperties = v1_CoachFeedEntryPoint_ClickedProperties;
class v1_CoachFeed_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_CoachFeed_ViewedProperties = v1_CoachFeed_ViewedProperties;
class v1_CoachFeedbackCancel_ClickedProperties {
  static CancelType = {
    undo: 'undo',
    cancel: 'cancel'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['cancel_type', 'concept', 'container_type', 'feedback_type', 'task_id']);
    var fixedNumber = 0;
    if (!Object.values(v1_CoachFeedbackCancel_ClickedProperties.CancelType).includes(this.payload.cancel_type)) {
      console.error('Invalid cancel_type value');
    }
    if (!(typeof this.payload.concept === 'string' || this.payload.concept instanceof String)) {
      console.error('concept must be of type String');
    }
    if (!(typeof this.payload.container_type === 'string' || this.payload.container_type instanceof String)) {
      console.error('container_type must be of type String');
    }
    if (!Object.values(_enum_properties.FeedbackType).includes(this.payload.feedback_type)) {
      console.error('Invalid feedback_type value');
    }
    if (!(typeof this.payload.task_id === 'string' || this.payload.task_id instanceof String)) {
      console.error('task_id must be of type String');
    }
    if (this.payload.item_id != null && !(typeof this.payload.item_id === 'string' || this.payload.item_id instanceof String)) {
      console.error('item_id must be of type String');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['cancel_type', 'concept', 'container_type', 'feedback_type', 'task_id', 'item_id', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_CoachFeedbackCancel_ClickedProperties = v1_CoachFeedbackCancel_ClickedProperties;
class v1_CoachFeedback_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['concept', 'container_type', 'feedback_type', 'task_id']);
    var fixedNumber = 0;
    if (!(typeof this.payload.concept === 'string' || this.payload.concept instanceof String)) {
      console.error('concept must be of type String');
    }
    if (!(typeof this.payload.container_type === 'string' || this.payload.container_type instanceof String)) {
      console.error('container_type must be of type String');
    }
    if (!Object.values(_enum_properties.FeedbackType).includes(this.payload.feedback_type)) {
      console.error('Invalid feedback_type value');
    }
    if (!(typeof this.payload.task_id === 'string' || this.payload.task_id instanceof String)) {
      console.error('task_id must be of type String');
    }
    if (this.payload.item_id != null && !(typeof this.payload.item_id === 'string' || this.payload.item_id instanceof String)) {
      console.error('item_id must be of type String');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['concept', 'container_type', 'feedback_type', 'task_id', 'item_id', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_CoachFeedback_ClickedProperties = v1_CoachFeedback_ClickedProperties;
class v1_CoachFeedback_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['concept', 'container_type', 'feedback_type', 'reason', 'task_id']);
    var fixedNumber = 0;
    if (!(typeof this.payload.concept === 'string' || this.payload.concept instanceof String)) {
      console.error('concept must be of type String');
    }
    if (!(typeof this.payload.container_type === 'string' || this.payload.container_type instanceof String)) {
      console.error('container_type must be of type String');
    }
    if (!Object.values(_enum_properties.FeedbackType).includes(this.payload.feedback_type)) {
      console.error('Invalid feedback_type value');
    }
    if (!(typeof this.payload.reason === 'string' || this.payload.reason instanceof String)) {
      console.error('reason must be of type String');
    }
    if (!(typeof this.payload.task_id === 'string' || this.payload.task_id instanceof String)) {
      console.error('task_id must be of type String');
    }
    if (this.payload.item_id != null && !(typeof this.payload.item_id === 'string' || this.payload.item_id instanceof String)) {
      console.error('item_id must be of type String');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['concept', 'container_type', 'feedback_type', 'reason', 'task_id', 'item_id', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_CoachFeedback_SubmittedProperties = v1_CoachFeedback_SubmittedProperties;
class v1_CoachModule_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['concept', 'container_type', 'task_id']);
    var fixedNumber = 0;
    if (!(typeof this.payload.concept === 'string' || this.payload.concept instanceof String)) {
      console.error('concept must be of type String');
    }
    if (!(typeof this.payload.container_type === 'string' || this.payload.container_type instanceof String)) {
      console.error('container_type must be of type String');
    }
    if (!(typeof this.payload.task_id === 'string' || this.payload.task_id instanceof String)) {
      console.error('task_id must be of type String');
    }
    if (this.payload.action != null && !(typeof this.payload.action === 'string' || this.payload.action instanceof String)) {
      console.error('action must be of type String');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.link_url != null && !(typeof this.payload.link_url === 'string' || this.payload.link_url instanceof String)) {
      console.error('link_url must be of type String');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.text != null && !(typeof this.payload.text === 'string' || this.payload.text instanceof String)) {
      console.error('text must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['concept', 'container_type', 'task_id', 'action', 'flow_type', 'link_url', 'screen', 'security_ticker', 'text', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_CoachModule_ClickedProperties = v1_CoachModule_ClickedProperties;
class v1_CoachModule_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['concept', 'container_type', 'task_id']);
    var fixedNumber = 0;
    if (!(typeof this.payload.concept === 'string' || this.payload.concept instanceof String)) {
      console.error('concept must be of type String');
    }
    if (!(typeof this.payload.container_type === 'string' || this.payload.container_type instanceof String)) {
      console.error('container_type must be of type String');
    }
    if (!(typeof this.payload.task_id === 'string' || this.payload.task_id instanceof String)) {
      console.error('task_id must be of type String');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['concept', 'container_type', 'task_id', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_CoachModule_ViewedProperties = v1_CoachModule_ViewedProperties;
class v1_Collection_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['collection_name', 'investment_type', 'screen']);
    var fixedNumber = 0;
    if (!(typeof this.payload.collection_name === 'string' || this.payload.collection_name instanceof String)) {
      console.error('collection_name must be of type String');
    }
    if (!Object.values(_enum_properties.InvestmentType).includes(this.payload.investment_type)) {
      console.error('Invalid investment_type value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['collection_name', 'investment_type', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Collection_ClickedProperties = v1_Collection_ClickedProperties;
class v1_ConfirmPII_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ConfirmPII_SubmittedProperties = v1_ConfirmPII_SubmittedProperties;
class v1_ConfirmPII_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ConfirmPII_ViewedProperties = v1_ConfirmPII_ViewedProperties;
class v1_ContactStashSupportStart_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ContactStashSupportStart_ClickedProperties = v1_ContactStashSupportStart_ClickedProperties;
class v1_ContactStashSupport_ClickedProperties {
  static ContactType = {
    email: 'email',
    phone: 'phone'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['contact_type', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(v1_ContactStashSupport_ClickedProperties.ContactType).includes(this.payload.contact_type)) {
      console.error('Invalid contact_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['contact_type', 'origin', 'screen', 'flow_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ContactStashSupport_ClickedProperties = v1_ContactStashSupport_ClickedProperties;
class v1_ContactStashSupport_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen', 'flow_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ContactStashSupport_ViewedProperties = v1_ContactStashSupport_ViewedProperties;
class v1_ContributionSetup_CompletedProperties {
  static Option = {
    entireAmount: 'entire_amount',
    percentage: 'percentage',
    specificAmount: 'specific_amount'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.amount != null) {
      fixedNumber = canFixNumber(this.payload.amount);
      if (fixedNumber === false) {
        console.error('amount must be of type Number');
      } else {
        this.payload.amount = fixedNumber;
      }
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.option != null && !Object.values(v1_ContributionSetup_CompletedProperties.Option).includes(this.payload.option)) {
      console.error('Invalid option value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'flow_type', 'option', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ContributionSetup_CompletedProperties = v1_ContributionSetup_CompletedProperties;
class v1_ContributionSetup_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ContributionSetup_ViewedProperties = v1_ContributionSetup_ViewedProperties;
class v1_Definition_ClickedProperties {
  static DefinitionType = {
    glossary: 'glossary',
    term: 'term'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['definition_type', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(v1_Definition_ClickedProperties.DefinitionType).includes(this.payload.definition_type)) {
      console.error('Invalid definition_type value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.definition_name != null && !(typeof this.payload.definition_name === 'string' || this.payload.definition_name instanceof String)) {
      console.error('definition_name must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['definition_type', 'screen', 'definition_name']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Definition_ClickedProperties = v1_Definition_ClickedProperties;
class v1_DepositSetup_ClickedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'frequency_type', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(v1_DepositSetup_ClickedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_DepositSetup_ClickedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.amount != null) {
      fixedNumber = canFixNumber(this.payload.amount);
      if (fixedNumber === false) {
        console.error('amount must be of type Number');
      } else {
        this.payload.amount = fixedNumber;
      }
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['destination', 'destination_management_type', 'flow_type', 'frequency_type', 'origin', 'screen', 'amount', 'security_ticker', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_DepositSetup_ClickedProperties = v1_DepositSetup_ClickedProperties;
class v1_DepositSetup_FailedProperties {
  static ErrorType = {
    apiError: 'api_error'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['error_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_DepositSetup_FailedProperties.ErrorType).includes(this.payload.error_type)) {
      console.error('Invalid error_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['error_type', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_DepositSetup_FailedProperties = v1_DepositSetup_FailedProperties;
class v1_DepositSetup_SubmittedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira',
    custodial: 'custodial',
    bank: 'bank',
    retirement: 'retirement'
  };
  static DestinationManagementType = {
    selfDirected: 'self_directed',
    robo: 'robo'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'frequency_type']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_DepositSetup_SubmittedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_DepositSetup_SubmittedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'frequency_type', 'flow_type', 'frequency_schedule', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_DepositSetup_SubmittedProperties = v1_DepositSetup_SubmittedProperties;
class v1_DepositSetup_SucceededProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira',
    custodial: 'custodial',
    bank: 'bank',
    retirement: 'retirement'
  };
  static DestinationManagementType = {
    selfDirected: 'self_directed',
    robo: 'robo'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'frequency_type']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_DepositSetup_SucceededProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_DepositSetup_SucceededProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.email != null && !(typeof this.payload.email === 'string' || this.payload.email instanceof String)) {
      console.error('email must be of type String');
    }
    if (this.payload.first_name != null && !(typeof this.payload.first_name === 'string' || this.payload.first_name instanceof String)) {
      console.error('first_name must be of type String');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.last_name != null && !(typeof this.payload.last_name === 'string' || this.payload.last_name instanceof String)) {
      console.error('last_name must be of type String');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.phone_number != null && !(typeof this.payload.phone_number === 'string' || this.payload.phone_number instanceof String)) {
      console.error('phone_number must be of type String');
    }
    if (this.payload.user_dob != null && !(this.payload.user_dob instanceof Date)) {
      console.error('user_dob must be of type Date');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'frequency_type', 'email', 'first_name', 'flow_type', 'frequency_schedule', 'last_name', 'origin', 'phone_number', 'user_dob']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_DepositSetup_SucceededProperties = v1_DepositSetup_SucceededProperties;
class v1_DirectDepositCard_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_DirectDepositCard_ClickedProperties = v1_DirectDepositCard_ClickedProperties;
class v1_DirectDepositCard_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_DirectDepositCard_ViewedProperties = v1_DirectDepositCard_ViewedProperties;
class v1_DiversificationAnalysisAssetClass_ClickedProperties {
  static AssetClassStatus = {
    underTarget: 'under_target',
    onTrack: 'on_track',
    onTarget: 'on_target',
    overTarget: 'over_target',
    unknown: 'unknown'
  };
  static AssetClassType = {
    fixedIncome: 'fixed_income',
    unitedStatesEquities: 'united_states_equities',
    internationalDevelopedEquities: 'international_developed_equities',
    internationalEmergingEquities: 'international_emerging_equities',
    alternative: 'alternative',
    unknown: 'unknown'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['asset_class_status', 'asset_class_type', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(v1_DiversificationAnalysisAssetClass_ClickedProperties.AssetClassStatus).includes(this.payload.asset_class_status)) {
      console.error('Invalid asset_class_status value');
    }
    if (!Object.values(v1_DiversificationAnalysisAssetClass_ClickedProperties.AssetClassType).includes(this.payload.asset_class_type)) {
      console.error('Invalid asset_class_type value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['asset_class_status', 'asset_class_type', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_DiversificationAnalysisAssetClass_ClickedProperties = v1_DiversificationAnalysisAssetClass_ClickedProperties;
class v1_DiversificationAnalysisInfo_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_DiversificationAnalysisInfo_ClickedProperties = v1_DiversificationAnalysisInfo_ClickedProperties;
class v1_DiversificationAnalysis_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_DiversificationAnalysis_ClickedProperties = v1_DiversificationAnalysis_ClickedProperties;
class v1_Document_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['document_type', 'flow_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.DocumentType).includes(this.payload.document_type)) {
      console.error('Invalid document_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['document_type', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Document_ClickedProperties = v1_Document_ClickedProperties;
class v1_Email_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Email_SubmittedProperties = v1_Email_SubmittedProperties;
class v1_EmploymentInfoEntry_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'flow_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_EmploymentInfoEntry_ViewedProperties = v1_EmploymentInfoEntry_ViewedProperties;
class v1_EmploymentInfo_SubmittedProperties {
  static EmploymentStatus = {
    employed: 'employed',
    partTimeEmployed: 'part_time_employed',
    student: 'student',
    retired: 'retired',
    freelancer: 'freelancer',
    unemployed: 'unemployed'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['employment_status', 'flow_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_EmploymentInfo_SubmittedProperties.EmploymentStatus).includes(this.payload.employment_status)) {
      console.error('Invalid employment_status value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['employment_status', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_EmploymentInfo_SubmittedProperties = v1_EmploymentInfo_SubmittedProperties;
class v1_EmploymentInfo_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_EmploymentInfo_ViewedProperties = v1_EmploymentInfo_ViewedProperties;
class v1_EscapeHatchEntry_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_EscapeHatchEntry_ViewedProperties = v1_EscapeHatchEntry_ViewedProperties;
class v1_EscapeHatch_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_EscapeHatch_ClickedProperties = v1_EscapeHatch_ClickedProperties;
class v1_ExpandCategories_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ExpandCategories_ClickedProperties = v1_ExpandCategories_ClickedProperties;
class v1_Experiment_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['experiment', 'variant']);
    var fixedNumber = 0;
    if (!(typeof this.payload.experiment === 'string' || this.payload.experiment instanceof String)) {
      console.error('experiment must be of type String');
    }
    if (!(typeof this.payload.variant === 'string' || this.payload.variant instanceof String)) {
      console.error('variant must be of type String');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['experiment', 'variant', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Experiment_ViewedProperties = v1_Experiment_ViewedProperties;
class v1_ExternalAccountChasePartial_ClickedProperties {
  static Cta = {
    yesChase: 'yes_chase',
    noChase: 'no_chase'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['cta']);
    var fixedNumber = 0;
    if (!Object.values(v1_ExternalAccountChasePartial_ClickedProperties.Cta).includes(this.payload.cta)) {
      console.error('Invalid cta value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['cta']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ExternalAccountChasePartial_ClickedProperties = v1_ExternalAccountChasePartial_ClickedProperties;
class v1_ExternalAccountChooseBank_ClickedProperties {
  static ExternalAccountConnectionType = {
    instant: 'instant'
  };
  static ExternalAccountType = {
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['external_account_connection_type', 'external_account_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_ExternalAccountChooseBank_ClickedProperties.ExternalAccountConnectionType).includes(this.payload.external_account_connection_type)) {
      console.error('Invalid external_account_connection_type value');
    }
    if (!Object.values(v1_ExternalAccountChooseBank_ClickedProperties.ExternalAccountType).includes(this.payload.external_account_type)) {
      console.error('Invalid external_account_type value');
    }
    if (this.payload.external_institution_name != null && !(typeof this.payload.external_institution_name === 'string' || this.payload.external_institution_name instanceof String)) {
      console.error('external_institution_name must be of type String');
    }
    if (this.payload.external_link_session_id != null && !(typeof this.payload.external_link_session_id === 'string' || this.payload.external_link_session_id instanceof String)) {
      console.error('external_link_session_id must be of type String');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['external_account_connection_type', 'external_account_type', 'external_institution_name', 'external_link_session_id', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ExternalAccountChooseBank_ClickedProperties = v1_ExternalAccountChooseBank_ClickedProperties;
class v1_ExternalAccountLinkFailed_ViewedProperties {
  static Variation = {
    exceededAttempts: 'exceeded_attempts',
    incorrectMicros: 'incorrect_micros',
    cannotConfirm: 'cannot_confirm'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['variation']);
    var fixedNumber = 0;
    if (!Object.values(v1_ExternalAccountLinkFailed_ViewedProperties.Variation).includes(this.payload.variation)) {
      console.error('Invalid variation value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['variation', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ExternalAccountLinkFailed_ViewedProperties = v1_ExternalAccountLinkFailed_ViewedProperties;
class v1_ExternalAccountLinkPrimer_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ExternalAccountLinkPrimer_ClickedProperties = v1_ExternalAccountLinkPrimer_ClickedProperties;
class v1_ExternalAccountLinkProcessing_ViewedProperties {
  static ExternalAccountType = {
    bank: 'bank',
    creditDebit: 'credit_debit'
  };
  static ExternalAccountConnectionType = {
    instant: 'instant',
    microDeposits: 'micro_deposits'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['external_account_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_ExternalAccountLinkProcessing_ViewedProperties.ExternalAccountType).includes(this.payload.external_account_type)) {
      console.error('Invalid external_account_type value');
    }
    if (this.payload.external_account_connection_type != null && !Object.values(v1_ExternalAccountLinkProcessing_ViewedProperties.ExternalAccountConnectionType).includes(this.payload.external_account_connection_type)) {
      console.error('Invalid external_account_connection_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['external_account_type', 'external_account_connection_type', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ExternalAccountLinkProcessing_ViewedProperties = v1_ExternalAccountLinkProcessing_ViewedProperties;
class v1_ExternalAccountLinkSetupResults_ViewedProperties {
  static ExternalAccountType = {
    bank: 'bank',
    creditDebit: 'credit_debit'
  };
  static Result = {
    success: 'success',
    failure: 'failure'
  };
  static ExternalAccountConnectionType = {
    instant: 'instant',
    microDeposits: 'micro_deposits'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['external_account_type', 'result']);
    var fixedNumber = 0;
    if (!Object.values(v1_ExternalAccountLinkSetupResults_ViewedProperties.ExternalAccountType).includes(this.payload.external_account_type)) {
      console.error('Invalid external_account_type value');
    }
    if (!Object.values(v1_ExternalAccountLinkSetupResults_ViewedProperties.Result).includes(this.payload.result)) {
      console.error('Invalid result value');
    }
    if (this.payload.external_account_connection_type != null && !Object.values(v1_ExternalAccountLinkSetupResults_ViewedProperties.ExternalAccountConnectionType).includes(this.payload.external_account_connection_type)) {
      console.error('Invalid external_account_connection_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['external_account_type', 'result', 'external_account_connection_type', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ExternalAccountLinkSetupResults_ViewedProperties = v1_ExternalAccountLinkSetupResults_ViewedProperties;
class v1_ExternalAccountLinkSetup_ClosedProperties {
  static ExternalAccountConnectionType = {
    instant: 'instant'
  };
  static ExternalAccountType = {
    bank: 'bank'
  };
  static LinkStatus = {
    requiresQuestions: 'requires_questions',
    requiresSelections: 'requires_selections',
    requiresCode: 'requires_code',
    chooseDevice: 'choose_device',
    requiresCredentials: 'requires_credentials',
    requiresAccountSelection: 'requires_account_selection',
    requiresOauth: 'requires_oauth',
    institutionNotFound: 'institution_not_found',
    institutionNotSupported: 'institution_not_supported',
    invalidCredentials: 'invalid_credentials',
    other: 'other'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['external_account_connection_type', 'external_account_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_ExternalAccountLinkSetup_ClosedProperties.ExternalAccountConnectionType).includes(this.payload.external_account_connection_type)) {
      console.error('Invalid external_account_connection_type value');
    }
    if (!Object.values(v1_ExternalAccountLinkSetup_ClosedProperties.ExternalAccountType).includes(this.payload.external_account_type)) {
      console.error('Invalid external_account_type value');
    }
    if (this.payload.error_message != null && !(typeof this.payload.error_message === 'string' || this.payload.error_message instanceof String)) {
      console.error('error_message must be of type String');
    }
    if (this.payload.external_institution_name != null && !(typeof this.payload.external_institution_name === 'string' || this.payload.external_institution_name instanceof String)) {
      console.error('external_institution_name must be of type String');
    }
    if (this.payload.external_link_session_id != null && !(typeof this.payload.external_link_session_id === 'string' || this.payload.external_link_session_id instanceof String)) {
      console.error('external_link_session_id must be of type String');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.link_status != null && !Object.values(v1_ExternalAccountLinkSetup_ClosedProperties.LinkStatus).includes(this.payload.link_status)) {
      console.error('Invalid link_status value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['external_account_connection_type', 'external_account_type', 'error_message', 'external_institution_name', 'external_link_session_id', 'flow_type', 'link_status', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ExternalAccountLinkSetup_ClosedProperties = v1_ExternalAccountLinkSetup_ClosedProperties;
class v1_ExternalAccountLinkSetup_FailedProperties {
  static ErrorType = {
    apiError: 'api_error',
    validationError: 'validation_error'
  };
  static ExternalAccountConnectionType = {
    instant: 'instant',
    microDeposits: 'micro_deposits'
  };
  static ExternalAccountProvider = {
    plaid: 'plaid',
    tabapay: 'tabapay',
    apex: 'apex'
  };
  static ExternalAccountType = {
    creditDebit: 'credit_debit',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['error_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_ExternalAccountLinkSetup_FailedProperties.ErrorType).includes(this.payload.error_type)) {
      console.error('Invalid error_type value');
    }
    if (this.payload.external_account_connection_type != null && !Object.values(v1_ExternalAccountLinkSetup_FailedProperties.ExternalAccountConnectionType).includes(this.payload.external_account_connection_type)) {
      console.error('Invalid external_account_connection_type value');
    }
    if (this.payload.external_account_provider != null && !Object.values(v1_ExternalAccountLinkSetup_FailedProperties.ExternalAccountProvider).includes(this.payload.external_account_provider)) {
      console.error('Invalid external_account_provider value');
    }
    if (this.payload.external_account_type != null && !Object.values(v1_ExternalAccountLinkSetup_FailedProperties.ExternalAccountType).includes(this.payload.external_account_type)) {
      console.error('Invalid external_account_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['error_type', 'external_account_connection_type', 'external_account_provider', 'external_account_type', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ExternalAccountLinkSetup_FailedProperties = v1_ExternalAccountLinkSetup_FailedProperties;
class v1_ExternalAccountLinkSetup_SubmittedProperties {
  static ExternalAccountType = {
    bank: 'bank',
    creditDebit: 'credit_debit'
  };
  static ExternalAccountConnectionType = {
    instant: 'instant',
    microDeposits: 'micro_deposits'
  };
  static ExternalAccountProvider = {
    plaid: 'plaid',
    tabapay: 'tabapay',
    apex: 'apex'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['external_account_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_ExternalAccountLinkSetup_SubmittedProperties.ExternalAccountType).includes(this.payload.external_account_type)) {
      console.error('Invalid external_account_type value');
    }
    if (this.payload.external_account_connection_type != null && !Object.values(v1_ExternalAccountLinkSetup_SubmittedProperties.ExternalAccountConnectionType).includes(this.payload.external_account_connection_type)) {
      console.error('Invalid external_account_connection_type value');
    }
    if (this.payload.external_account_provider != null && !Object.values(v1_ExternalAccountLinkSetup_SubmittedProperties.ExternalAccountProvider).includes(this.payload.external_account_provider)) {
      console.error('Invalid external_account_provider value');
    }
    if (this.payload.external_institution_name != null && !(typeof this.payload.external_institution_name === 'string' || this.payload.external_institution_name instanceof String)) {
      console.error('external_institution_name must be of type String');
    }
    if (this.payload.external_link_session_id != null && !(typeof this.payload.external_link_session_id === 'string' || this.payload.external_link_session_id instanceof String)) {
      console.error('external_link_session_id must be of type String');
    }
    if (this.payload.externallink_id != null && !(typeof this.payload.externallink_id === 'string' || this.payload.externallink_id instanceof String)) {
      console.error('externallink_id must be of type String');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['external_account_type', 'external_account_connection_type', 'external_account_provider', 'external_institution_name', 'external_link_session_id', 'externallink_id', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ExternalAccountLinkSetup_SubmittedProperties = v1_ExternalAccountLinkSetup_SubmittedProperties;
class v1_ExternalAccountLinkSetup_SucceededProperties {
  static ExternalAccountConnectionType = {
    instant: 'instant',
    microDeposits: 'micro_deposits'
  };
  static ExternalAccountProvider = {
    plaid: 'plaid',
    tabapay: 'tabapay',
    apex: 'apex'
  };
  static ExternalAccountType = {
    bank: 'bank',
    creditDebit: 'credit_debit'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.external_account_connection_type != null && !Object.values(v1_ExternalAccountLinkSetup_SucceededProperties.ExternalAccountConnectionType).includes(this.payload.external_account_connection_type)) {
      console.error('Invalid external_account_connection_type value');
    }
    if (this.payload.external_account_provider != null && !Object.values(v1_ExternalAccountLinkSetup_SucceededProperties.ExternalAccountProvider).includes(this.payload.external_account_provider)) {
      console.error('Invalid external_account_provider value');
    }
    if (this.payload.external_account_type != null && !Object.values(v1_ExternalAccountLinkSetup_SucceededProperties.ExternalAccountType).includes(this.payload.external_account_type)) {
      console.error('Invalid external_account_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['external_account_connection_type', 'external_account_provider', 'external_account_type', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ExternalAccountLinkSetup_SucceededProperties = v1_ExternalAccountLinkSetup_SucceededProperties;
class v1_ExternalAccountLinkSetup_ViewedProperties {
  static ExternalAccountType = {
    bank: 'bank',
    creditDebit: 'credit_debit'
  };
  static ExternalAccountConnectionType = {
    instant: 'instant',
    microDeposits: 'micro_deposits'
  };
  static ExternalAccountProvider = {
    tabapay: 'tabapay',
    plaid: 'plaid'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['external_account_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_ExternalAccountLinkSetup_ViewedProperties.ExternalAccountType).includes(this.payload.external_account_type)) {
      console.error('Invalid external_account_type value');
    }
    if (this.payload.external_account_connection_type != null && !Object.values(v1_ExternalAccountLinkSetup_ViewedProperties.ExternalAccountConnectionType).includes(this.payload.external_account_connection_type)) {
      console.error('Invalid external_account_connection_type value');
    }
    if (this.payload.external_account_provider != null && !Object.values(v1_ExternalAccountLinkSetup_ViewedProperties.ExternalAccountProvider).includes(this.payload.external_account_provider)) {
      console.error('Invalid external_account_provider value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['external_account_type', 'external_account_connection_type', 'external_account_provider', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ExternalAccountLinkSetup_ViewedProperties = v1_ExternalAccountLinkSetup_ViewedProperties;
class v1_ExternalAccountLinkStart_ClickedProperties {
  static ExternalAccountConnectionType = {
    instant: 'instant',
    microDeposits: 'micro_deposits'
  };
  static ExternalAccountType = {
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.external_account_connection_type != null && !Object.values(v1_ExternalAccountLinkStart_ClickedProperties.ExternalAccountConnectionType).includes(this.payload.external_account_connection_type)) {
      console.error('Invalid external_account_connection_type value');
    }
    if (this.payload.external_account_type != null && !Object.values(v1_ExternalAccountLinkStart_ClickedProperties.ExternalAccountType).includes(this.payload.external_account_type)) {
      console.error('Invalid external_account_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.tile_id != null && !(typeof this.payload.tile_id === 'string' || this.payload.tile_id instanceof String)) {
      console.error('tile_id must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['external_account_connection_type', 'external_account_type', 'flow_type', 'origin', 'screen', 'tile_id']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ExternalAccountLinkStart_ClickedProperties = v1_ExternalAccountLinkStart_ClickedProperties;
class v1_ExternalAccountLinkStart_ViewedProperties {
  static ExternalAccountType = {
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.external_account_type != null && !Object.values(v1_ExternalAccountLinkStart_ViewedProperties.ExternalAccountType).includes(this.payload.external_account_type)) {
      console.error('Invalid external_account_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['external_account_type', 'flow_type', 'origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ExternalAccountLinkStart_ViewedProperties = v1_ExternalAccountLinkStart_ViewedProperties;
class v1_ExternalAccountLink_ClickedProperties {
  static ExternalAccountConnectionType = {
    instant: 'instant',
    microDeposits: 'micro_deposits'
  };
  static ExternalAccountType = {
    creditDebit: 'credit_debit',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.external_account_connection_type != null && !Object.values(v1_ExternalAccountLink_ClickedProperties.ExternalAccountConnectionType).includes(this.payload.external_account_connection_type)) {
      console.error('Invalid external_account_connection_type value');
    }
    if (this.payload.external_account_type != null && !Object.values(v1_ExternalAccountLink_ClickedProperties.ExternalAccountType).includes(this.payload.external_account_type)) {
      console.error('Invalid external_account_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['screen', 'external_account_connection_type', 'external_account_type', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ExternalAccountLink_ClickedProperties = v1_ExternalAccountLink_ClickedProperties;
class v1_ExternalAccountLink_ViewedProperties {
  static ExternalAccountType = {
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.external_account_type != null && !Object.values(v1_ExternalAccountLink_ViewedProperties.ExternalAccountType).includes(this.payload.external_account_type)) {
      console.error('Invalid external_account_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['external_account_type', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ExternalAccountLink_ViewedProperties = v1_ExternalAccountLink_ViewedProperties;
class v1_FinraAffiliate_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_FinraAffiliate_SubmittedProperties = v1_FinraAffiliate_SubmittedProperties;
class v1_FinraAffiliate_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_FinraAffiliate_ViewedProperties = v1_FinraAffiliate_ViewedProperties;
class v1_GoalCreateCancelOption_ClickedProperties {
  static ButtonClicked = {
    yesCancel: 'yes_cancel',
    noReturn: 'no_return'
  };
  static GoalType = {
    custom: 'custom'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['button_clicked', 'flow_type', 'goal_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_GoalCreateCancelOption_ClickedProperties.ButtonClicked).includes(this.payload.button_clicked)) {
      console.error('Invalid button_clicked value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(v1_GoalCreateCancelOption_ClickedProperties.GoalType).includes(this.payload.goal_type)) {
      console.error('Invalid goal_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['button_clicked', 'flow_type', 'goal_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_GoalCreateCancelOption_ClickedProperties = v1_GoalCreateCancelOption_ClickedProperties;
class v1_GoalCreateCancel_ClickedProperties {
  static GoalType = {
    custom: 'custom'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'goal_type', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(v1_GoalCreateCancel_ClickedProperties.GoalType).includes(this.payload.goal_type)) {
      console.error('Invalid goal_type value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'goal_type', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_GoalCreateCancel_ClickedProperties = v1_GoalCreateCancel_ClickedProperties;
class v1_GoalCreateNameEntry_ViewedProperties {
  static GoalType = {
    custom: 'custom'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'goal_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(v1_GoalCreateNameEntry_ViewedProperties.GoalType).includes(this.payload.goal_type)) {
      console.error('Invalid goal_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'goal_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_GoalCreateNameEntry_ViewedProperties = v1_GoalCreateNameEntry_ViewedProperties;
class v1_GoalCreateName_ClickedProperties {
  static GoalType = {
    custom: 'custom'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'goal_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(v1_GoalCreateName_ClickedProperties.GoalType).includes(this.payload.goal_type)) {
      console.error('Invalid goal_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'goal_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_GoalCreateName_ClickedProperties = v1_GoalCreateName_ClickedProperties;
class v1_GoalCreateStart_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_GoalCreateStart_ClickedProperties = v1_GoalCreateStart_ClickedProperties;
class v1_GoalCreateTargets_ViewedProperties {
  static GoalType = {
    custom: 'custom'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'goal_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(v1_GoalCreateTargets_ViewedProperties.GoalType).includes(this.payload.goal_type)) {
      console.error('Invalid goal_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'goal_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_GoalCreateTargets_ViewedProperties = v1_GoalCreateTargets_ViewedProperties;
class v1_GoalDetailDeleteOption_ClickedProperties {
  static ButtonClicked = {
    yesDelete: 'yes_delete',
    noReturn: 'no_return'
  };
  static GoalHorizon = {
    shortTerm: 'short_term',
    longTerm: 'long_term'
  };
  static GoalType = {
    custom: 'custom'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['button_clicked', 'goal_horizon', 'goal_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(v1_GoalDetailDeleteOption_ClickedProperties.ButtonClicked).includes(this.payload.button_clicked)) {
      console.error('Invalid button_clicked value');
    }
    if (!Object.values(v1_GoalDetailDeleteOption_ClickedProperties.GoalHorizon).includes(this.payload.goal_horizon)) {
      console.error('Invalid goal_horizon value');
    }
    if (!Object.values(v1_GoalDetailDeleteOption_ClickedProperties.GoalType).includes(this.payload.goal_type)) {
      console.error('Invalid goal_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['button_clicked', 'goal_horizon', 'goal_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_GoalDetailDeleteOption_ClickedProperties = v1_GoalDetailDeleteOption_ClickedProperties;
class v1_GoalDetailDelete_ClickedProperties {
  static GoalHorizon = {
    shortTerm: 'short_term',
    longTerm: 'long_term'
  };
  static GoalType = {
    custom: 'custom'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['goal_horizon', 'goal_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(v1_GoalDetailDelete_ClickedProperties.GoalHorizon).includes(this.payload.goal_horizon)) {
      console.error('Invalid goal_horizon value');
    }
    if (!Object.values(v1_GoalDetailDelete_ClickedProperties.GoalType).includes(this.payload.goal_type)) {
      console.error('Invalid goal_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['goal_horizon', 'goal_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_GoalDetailDelete_ClickedProperties = v1_GoalDetailDelete_ClickedProperties;
class v1_GoalDetailEdit_ClickedProperties {
  static GoalHorizon = {
    shortTerm: 'short_term',
    longTerm: 'long_term'
  };
  static GoalType = {
    custom: 'custom'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['goal_horizon', 'goal_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(v1_GoalDetailEdit_ClickedProperties.GoalHorizon).includes(this.payload.goal_horizon)) {
      console.error('Invalid goal_horizon value');
    }
    if (!Object.values(v1_GoalDetailEdit_ClickedProperties.GoalType).includes(this.payload.goal_type)) {
      console.error('Invalid goal_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['goal_horizon', 'goal_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_GoalDetailEdit_ClickedProperties = v1_GoalDetailEdit_ClickedProperties;
class v1_GoalDetails_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_GoalDetails_ClickedProperties = v1_GoalDetails_ClickedProperties;
class v1_GoalDetails_ViewedProperties {
  static GoalHorizon = {
    shortTerm: 'short_term',
    longTerm: 'long_term'
  };
  static GoalType = {
    custom: 'custom'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['goal_horizon', 'goal_id', 'goal_name', 'goal_target_amount', 'goal_target_date', 'goal_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(v1_GoalDetails_ViewedProperties.GoalHorizon).includes(this.payload.goal_horizon)) {
      console.error('Invalid goal_horizon value');
    }
    if (!(typeof this.payload.goal_id === 'string' || this.payload.goal_id instanceof String)) {
      console.error('goal_id must be of type String');
    }
    if (!(typeof this.payload.goal_name === 'string' || this.payload.goal_name instanceof String)) {
      console.error('goal_name must be of type String');
    }
    fixedNumber = canFixNumber(this.payload.goal_target_amount);
    if (fixedNumber === false) {
      console.error('goal_target_amount must be of type Number');
    } else {
      this.payload.goal_target_amount = fixedNumber;
    }
    if (!(this.payload.goal_target_date instanceof Date)) {
      console.error('goal_target_date must be of type Date');
    }
    if (!Object.values(v1_GoalDetails_ViewedProperties.GoalType).includes(this.payload.goal_type)) {
      console.error('Invalid goal_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['goal_horizon', 'goal_id', 'goal_name', 'goal_target_amount', 'goal_target_date', 'goal_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_GoalDetails_ViewedProperties = v1_GoalDetails_ViewedProperties;
class v1_Goal_SubmittedProperties {
  static GoalType = {
    custom: 'custom'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'goal_name', 'goal_target_amount', 'goal_target_date', 'goal_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!(typeof this.payload.goal_name === 'string' || this.payload.goal_name instanceof String)) {
      console.error('goal_name must be of type String');
    }
    fixedNumber = canFixNumber(this.payload.goal_target_amount);
    if (fixedNumber === false) {
      console.error('goal_target_amount must be of type Number');
    } else {
      this.payload.goal_target_amount = fixedNumber;
    }
    if (!(this.payload.goal_target_date instanceof Date)) {
      console.error('goal_target_date must be of type Date');
    }
    if (!Object.values(v1_Goal_SubmittedProperties.GoalType).includes(this.payload.goal_type)) {
      console.error('Invalid goal_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'goal_name', 'goal_target_amount', 'goal_target_date', 'goal_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Goal_SubmittedProperties = v1_Goal_SubmittedProperties;
class v1_GoalsHome_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_GoalsHome_ViewedProperties = v1_GoalsHome_ViewedProperties;
class v1_GoalsInfo_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_GoalsInfo_ClickedProperties = v1_GoalsInfo_ClickedProperties;
class v1_GraphTimeframe_ClickedProperties {
  static GraphType = {
    historicalPerformance: 'historical_performance'
  };
  static Timeframe = {
    allTime: 'all_time',
    oneMonth: 'one_month',
    oneYear: 'one_year',
    threeMonths: 'three_months'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['graph_type', 'screen', 'timeframe']);
    var fixedNumber = 0;
    if (!Object.values(v1_GraphTimeframe_ClickedProperties.GraphType).includes(this.payload.graph_type)) {
      console.error('Invalid graph_type value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (!Object.values(v1_GraphTimeframe_ClickedProperties.Timeframe).includes(this.payload.timeframe)) {
      console.error('Invalid timeframe value');
    }
    if (this.payload.account_type != null && !Object.values(_enum_properties.AccountType).includes(this.payload.account_type)) {
      console.error('Invalid account_type value');
    }
    if (this.payload.management_type != null && !Object.values(_enum_properties.ManagementType).includes(this.payload.management_type)) {
      console.error('Invalid management_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['graph_type', 'screen', 'timeframe', 'account_type', 'management_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_GraphTimeframe_ClickedProperties = v1_GraphTimeframe_ClickedProperties;
class v1_Graph_ClickedProperties {
  static GraphType = {
    historicalPerformance: 'historical_performance'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['graph_type', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(v1_Graph_ClickedProperties.GraphType).includes(this.payload.graph_type)) {
      console.error('Invalid graph_type value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.account_type != null && !Object.values(_enum_properties.AccountType).includes(this.payload.account_type)) {
      console.error('Invalid account_type value');
    }
    if (this.payload.management_type != null && !Object.values(_enum_properties.ManagementType).includes(this.payload.management_type)) {
      console.error('Invalid management_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['graph_type', 'screen', 'account_type', 'management_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Graph_ClickedProperties = v1_Graph_ClickedProperties;
class v1_HideCategories_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_HideCategories_ClickedProperties = v1_HideCategories_ClickedProperties;
class v1_HodorVerification_SucceededProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_HodorVerification_SucceededProperties = v1_HodorVerification_SucceededProperties;
class v1_Home_FailedProperties {
  static ErrorType = {
    apiError: 'api_error'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['error_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_Home_FailedProperties.ErrorType).includes(this.payload.error_type)) {
      console.error('Invalid error_type value');
    }
    if (this.payload.error_code != null && !(typeof this.payload.error_code === 'string' || this.payload.error_code instanceof String)) {
      console.error('error_code must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['error_type', 'error_code']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Home_FailedProperties = v1_Home_FailedProperties;
class v1_IDVCaptureConfirmation_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.document_type != null && !Object.values(_enum_properties.DocumentType).includes(this.payload.document_type)) {
      console.error('Invalid document_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'document_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_IDVCaptureConfirmation_ClickedProperties = v1_IDVCaptureConfirmation_ClickedProperties;
class v1_IDVCaptureConfirmation_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.document_type != null && !Object.values(_enum_properties.DocumentType).includes(this.payload.document_type)) {
      console.error('Invalid document_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'document_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_IDVCaptureConfirmation_ViewedProperties = v1_IDVCaptureConfirmation_ViewedProperties;
class v1_IDVCapture_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['document_type', 'flow_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.DocumentType).includes(this.payload.document_type)) {
      console.error('Invalid document_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['document_type', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_IDVCapture_ClickedProperties = v1_IDVCapture_ClickedProperties;
class v1_IDVCapture_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['document_type', 'flow_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.DocumentType).includes(this.payload.document_type)) {
      console.error('Invalid document_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['document_type', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_IDVCapture_ViewedProperties = v1_IDVCapture_ViewedProperties;
class v1_IDVEntry_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_IDVEntry_ViewedProperties = v1_IDVEntry_ViewedProperties;
class v1_IDVMiskey_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_IDVMiskey_SubmittedProperties = v1_IDVMiskey_SubmittedProperties;
class v1_IDVMiskey_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_IDVMiskey_ViewedProperties = v1_IDVMiskey_ViewedProperties;
class v1_IDVResult_ClickedProperties {
  static FraudStatus = {
    approved: 'approved',
    hardFail: 'hard_fail',
    waitingRoom: 'waiting_room'
  };
  static Result = {
    succeeded: 'succeeded',
    rejected: 'rejected',
    error: 'error',
    docUpload: 'doc_upload',
    reviewPii: 'review_pii',
    manualReview: 'manual_review'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['fraud_status', 'origin', 'result']);
    var fixedNumber = 0;
    if (!Object.values(v1_IDVResult_ClickedProperties.FraudStatus).includes(this.payload.fraud_status)) {
      console.error('Invalid fraud_status value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_IDVResult_ClickedProperties.Result).includes(this.payload.result)) {
      console.error('Invalid result value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['fraud_status', 'origin', 'result']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_IDVResult_ClickedProperties = v1_IDVResult_ClickedProperties;
class v1_IDVResult_ViewedProperties {
  static FraudStatus = {
    approved: 'approved',
    hardFail: 'hard_fail',
    waitingRoom: 'waiting_room',
    error: 'error'
  };
  static Result = {
    succeeded: 'succeeded',
    rejected: 'rejected',
    error: 'error',
    docUpload: 'doc_upload',
    reviewPii: 'review_pii',
    manualReview: 'manual_review'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['fraud_status', 'origin', 'result']);
    var fixedNumber = 0;
    if (!Object.values(v1_IDVResult_ViewedProperties.FraudStatus).includes(this.payload.fraud_status)) {
      console.error('Invalid fraud_status value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_IDVResult_ViewedProperties.Result).includes(this.payload.result)) {
      console.error('Invalid result value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['fraud_status', 'origin', 'result']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_IDVResult_ViewedProperties = v1_IDVResult_ViewedProperties;
class v1_InternalNotificationAction_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin', 'screen', 'tile_id']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (!(typeof this.payload.tile_id === 'string' || this.payload.tile_id instanceof String)) {
      console.error('tile_id must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen', 'tile_id']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_InternalNotificationAction_ClickedProperties = v1_InternalNotificationAction_ClickedProperties;
class v1_InternalNotificationDismiss_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin', 'screen', 'tile_id']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (!(typeof this.payload.tile_id === 'string' || this.payload.tile_id instanceof String)) {
      console.error('tile_id must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen', 'tile_id']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_InternalNotificationDismiss_ClickedProperties = v1_InternalNotificationDismiss_ClickedProperties;
class v1_InternalNotification_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin', 'screen', 'tile_id']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (!(typeof this.payload.tile_id === 'string' || this.payload.tile_id instanceof String)) {
      console.error('tile_id must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen', 'tile_id']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_InternalNotification_ViewedProperties = v1_InternalNotification_ViewedProperties;
class v1_InternalTransferSetup_FailedProperties {
  static ErrorType = {
    apiError: 'api_error'
  };
  static Destination = {
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira',
    personalBrokerage: 'personal_brokerage',
    custodial: 'custodial'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['error_type', 'flow_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_InternalTransferSetup_FailedProperties.ErrorType).includes(this.payload.error_type)) {
      console.error('Invalid error_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.amount != null) {
      fixedNumber = canFixNumber(this.payload.amount);
      if (fixedNumber === false) {
        console.error('amount must be of type Number');
      } else {
        this.payload.amount = fixedNumber;
      }
    }
    if (this.payload.currency != null && !(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (this.payload.destination != null && !Object.values(v1_InternalTransferSetup_FailedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (this.payload.destination_management_type != null && !Object.values(v1_InternalTransferSetup_FailedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (this.payload.error_code != null && !(typeof this.payload.error_code === 'string' || this.payload.error_code instanceof String)) {
      console.error('error_code must be of type String');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.frequency_type != null && !Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.source != null && !Object.values(v1_InternalTransferSetup_FailedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['error_type', 'flow_type', 'amount', 'currency', 'destination', 'destination_management_type', 'error_code', 'frequency_schedule', 'frequency_type', 'origin', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_InternalTransferSetup_FailedProperties = v1_InternalTransferSetup_FailedProperties;
class v1_InternalTransferSetup_SubmittedProperties {
  static Destination = {
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira',
    personalBrokerage: 'personal_brokerage',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira',
    personalBrokerage: 'personal_brokerage',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank'
  };
  static SourceManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'flow_type', 'frequency_type', 'source', 'source_management_type']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_InternalTransferSetup_SubmittedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_InternalTransferSetup_SubmittedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (!Object.values(v1_InternalTransferSetup_SubmittedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (!Object.values(v1_InternalTransferSetup_SubmittedProperties.SourceManagementType).includes(this.payload.source_management_type)) {
      console.error('Invalid source_management_type value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'flow_type', 'frequency_type', 'source', 'source_management_type', 'frequency_schedule', 'origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_InternalTransferSetup_SubmittedProperties = v1_InternalTransferSetup_SubmittedProperties;
class v1_InternalTransferSetup_SucceededProperties {
  static Destination = {
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira',
    personalBrokerage: 'personal_brokerage',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira',
    personalBrokerage: 'personal_brokerage',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank'
  };
  static SourceManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'flow_type', 'frequency_type', 'source', 'source_management_type']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_InternalTransferSetup_SucceededProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_InternalTransferSetup_SucceededProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (!Object.values(v1_InternalTransferSetup_SucceededProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (!Object.values(v1_InternalTransferSetup_SucceededProperties.SourceManagementType).includes(this.payload.source_management_type)) {
      console.error('Invalid source_management_type value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'destination_management_type', 'flow_type', 'frequency_type', 'source', 'source_management_type', 'frequency_schedule', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_InternalTransferSetup_SucceededProperties = v1_InternalTransferSetup_SucceededProperties;
class v1_InvestPerformanceInfo_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_InvestPerformanceInfo_ClickedProperties = v1_InvestPerformanceInfo_ClickedProperties;
class v1_InvestingQuestionsEntry_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'flow_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_InvestingQuestionsEntry_ViewedProperties = v1_InvestingQuestionsEntry_ViewedProperties;
class v1_InvestingQuestions_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['income_range', 'net_worth_range', 'origin', 'risk_tolerance', 'time_horizon']);
    var fixedNumber = 0;
    if (!(typeof this.payload.income_range === 'string' || this.payload.income_range instanceof String)) {
      console.error('income_range must be of type String');
    }
    if (!(typeof this.payload.net_worth_range === 'string' || this.payload.net_worth_range instanceof String)) {
      console.error('net_worth_range must be of type String');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!(typeof this.payload.risk_tolerance === 'string' || this.payload.risk_tolerance instanceof String)) {
      console.error('risk_tolerance must be of type String');
    }
    if (!(typeof this.payload.time_horizon === 'string' || this.payload.time_horizon instanceof String)) {
      console.error('time_horizon must be of type String');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.has_children_under_eighteen != null && !(typeof this.payload.has_children_under_eighteen === 'string' || this.payload.has_children_under_eighteen instanceof String)) {
      console.error('has_children_under_eighteen must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['income_range', 'net_worth_range', 'origin', 'risk_tolerance', 'time_horizon', 'flow_type', 'has_children_under_eighteen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_InvestingQuestions_SubmittedProperties = v1_InvestingQuestions_SubmittedProperties;
class v1_InvestingTips_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['screen', 'slug']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (!(typeof this.payload.slug === 'string' || this.payload.slug instanceof String)) {
      console.error('slug must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['screen', 'slug']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_InvestingTips_ClickedProperties = v1_InvestingTips_ClickedProperties;
class v1_InvestingTips_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['slug']);
    var fixedNumber = 0;
    if (!(typeof this.payload.slug === 'string' || this.payload.slug instanceof String)) {
      console.error('slug must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['slug']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_InvestingTips_ViewedProperties = v1_InvestingTips_ViewedProperties;
class v1_InvestmentDetailsPartial_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'investment_type', 'origin', 'security_ticker']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.InvestmentType).includes(this.payload.investment_type)) {
      console.error('Invalid investment_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'investment_type', 'origin', 'security_ticker']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_InvestmentDetailsPartial_ClickedProperties = v1_InvestmentDetailsPartial_ClickedProperties;
class v1_InvestmentDetailsPartial_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'investment_type', 'origin', 'security_ticker']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.InvestmentType).includes(this.payload.investment_type)) {
      console.error('Invalid investment_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'investment_type', 'origin', 'security_ticker']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_InvestmentDetailsPartial_ViewedProperties = v1_InvestmentDetailsPartial_ViewedProperties;
class v1_InvestmentDetails_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['investment_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.InvestmentType).includes(this.payload.investment_type)) {
      console.error('Invalid investment_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['investment_type', 'origin', 'flow_type', 'screen', 'security_ticker', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_InvestmentDetails_ClickedProperties = v1_InvestmentDetails_ClickedProperties;
class v1_InvestmentDetails_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['investment_id', 'investment_name', 'investment_type']);
    var fixedNumber = 0;
    if (!(typeof this.payload.investment_id === 'string' || this.payload.investment_id instanceof String)) {
      console.error('investment_id must be of type String');
    }
    if (!(typeof this.payload.investment_name === 'string' || this.payload.investment_name instanceof String)) {
      console.error('investment_name must be of type String');
    }
    if (!Object.values(_enum_properties.InvestmentType).includes(this.payload.investment_type)) {
      console.error('Invalid investment_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['investment_id', 'investment_name', 'investment_type', 'flow_type', 'origin', 'security_ticker', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_InvestmentDetails_ViewedProperties = v1_InvestmentDetails_ViewedProperties;
class v1_LandingPage_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.button_cta != null && !(typeof this.payload.button_cta === 'string' || this.payload.button_cta instanceof String)) {
      console.error('button_cta must be of type String');
    }
    if (this.payload.utm_campaign != null && !(typeof this.payload.utm_campaign === 'string' || this.payload.utm_campaign instanceof String)) {
      console.error('utm_campaign must be of type String');
    }
    if (this.payload.utm_content != null && !(typeof this.payload.utm_content === 'string' || this.payload.utm_content instanceof String)) {
      console.error('utm_content must be of type String');
    }
    if (this.payload.utm_medium != null && !(typeof this.payload.utm_medium === 'string' || this.payload.utm_medium instanceof String)) {
      console.error('utm_medium must be of type String');
    }
    if (this.payload.utm_source != null && !(typeof this.payload.utm_source === 'string' || this.payload.utm_source instanceof String)) {
      console.error('utm_source must be of type String');
    }
    if (this.payload.utm_term != null && !(typeof this.payload.utm_term === 'string' || this.payload.utm_term instanceof String)) {
      console.error('utm_term must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['button_cta', 'utm_campaign', 'utm_content', 'utm_medium', 'utm_source', 'utm_term']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_LandingPage_ClickedProperties = v1_LandingPage_ClickedProperties;
class v1_LandingPage_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.utm_campaign != null && !(typeof this.payload.utm_campaign === 'string' || this.payload.utm_campaign instanceof String)) {
      console.error('utm_campaign must be of type String');
    }
    if (this.payload.utm_content != null && !(typeof this.payload.utm_content === 'string' || this.payload.utm_content instanceof String)) {
      console.error('utm_content must be of type String');
    }
    if (this.payload.utm_medium != null && !(typeof this.payload.utm_medium === 'string' || this.payload.utm_medium instanceof String)) {
      console.error('utm_medium must be of type String');
    }
    if (this.payload.utm_source != null && !(typeof this.payload.utm_source === 'string' || this.payload.utm_source instanceof String)) {
      console.error('utm_source must be of type String');
    }
    if (this.payload.utm_term != null && !(typeof this.payload.utm_term === 'string' || this.payload.utm_term instanceof String)) {
      console.error('utm_term must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['utm_campaign', 'utm_content', 'utm_medium', 'utm_source', 'utm_term']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_LandingPage_ViewedProperties = v1_LandingPage_ViewedProperties;
class v1_LearnAndEarnAction_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['deeplink', 'learn_id', 'origin', 'title']);
    var fixedNumber = 0;
    if (!(typeof this.payload.deeplink === 'string' || this.payload.deeplink instanceof String)) {
      console.error('deeplink must be of type String');
    }
    if (!(typeof this.payload.learn_id === 'string' || this.payload.learn_id instanceof String)) {
      console.error('learn_id must be of type String');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!(typeof this.payload.title === 'string' || this.payload.title instanceof String)) {
      console.error('title must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['deeplink', 'learn_id', 'origin', 'title']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_LearnAndEarnAction_ClickedProperties = v1_LearnAndEarnAction_ClickedProperties;
class v1_LearnAndEarn_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['learn_id', 'origin', 'title']);
    var fixedNumber = 0;
    if (!(typeof this.payload.learn_id === 'string' || this.payload.learn_id instanceof String)) {
      console.error('learn_id must be of type String');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!(typeof this.payload.title === 'string' || this.payload.title instanceof String)) {
      console.error('title must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['learn_id', 'origin', 'title']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_LearnAndEarn_ClickedProperties = v1_LearnAndEarn_ClickedProperties;
class v1_LearnAndEarn_CompletedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['learn_id', 'origin', 'title']);
    var fixedNumber = 0;
    if (!(typeof this.payload.learn_id === 'string' || this.payload.learn_id instanceof String)) {
      console.error('learn_id must be of type String');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!(typeof this.payload.title === 'string' || this.payload.title instanceof String)) {
      console.error('title must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['learn_id', 'origin', 'title']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_LearnAndEarn_CompletedProperties = v1_LearnAndEarn_CompletedProperties;
class v1_LearnAndEarn_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['learn_id', 'origin', 'title']);
    var fixedNumber = 0;
    if (!(typeof this.payload.learn_id === 'string' || this.payload.learn_id instanceof String)) {
      console.error('learn_id must be of type String');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!(typeof this.payload.title === 'string' || this.payload.title instanceof String)) {
      console.error('title must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['learn_id', 'origin', 'title']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_LearnAndEarn_SubmittedProperties = v1_LearnAndEarn_SubmittedProperties;
class v1_LearnAndEarn_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['learn_id', 'origin', 'title']);
    var fixedNumber = 0;
    if (!(typeof this.payload.learn_id === 'string' || this.payload.learn_id instanceof String)) {
      console.error('learn_id must be of type String');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!(typeof this.payload.title === 'string' || this.payload.title instanceof String)) {
      console.error('title must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['learn_id', 'origin', 'title']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_LearnAndEarn_ViewedProperties = v1_LearnAndEarn_ViewedProperties;
class v1_LearnContentMoat_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_LearnContentMoat_ClickedProperties = v1_LearnContentMoat_ClickedProperties;
class v1_Login_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Login_ClickedProperties = v1_Login_ClickedProperties;
class v1_Logout_SucceededProperties {
  static LogoutSource = {
    userInitiated: 'user_initiated',
    tokenExpired: 'token_expired',
    biometricsFailed: 'biometrics_failed',
    pinAttemptsFailed: 'pin_attempts_failed',
    networkError: 'network_error'
  };
  static IsAuthTokenDifferentFromCached = {
    yes: 'yes',
    no: 'no'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['logout_source']);
    var fixedNumber = 0;
    if (!Object.values(v1_Logout_SucceededProperties.LogoutSource).includes(this.payload.logout_source)) {
      console.error('Invalid logout_source value');
    }
    if (this.payload.access_token_remaining_seconds != null) {
      fixedNumber = canFixNumber(this.payload.access_token_remaining_seconds);
      if (fixedNumber === false) {
        console.error('access_token_remaining_seconds must be of type Number');
      } else {
        this.payload.access_token_remaining_seconds = fixedNumber;
      }
    }
    if (this.payload.expiration_date != null && !(this.payload.expiration_date instanceof Date)) {
      console.error('expiration_date must be of type Date');
    }
    if (this.payload.expired_after != null && !Object.values(_enum_properties.ExpiredAfter).includes(this.payload.expired_after)) {
      console.error('Invalid expired_after value');
    }
    if (this.payload.is_auth_token_different_from_cached != null && !Object.values(v1_Logout_SucceededProperties.IsAuthTokenDifferentFromCached).includes(this.payload.is_auth_token_different_from_cached)) {
      console.error('Invalid is_auth_token_different_from_cached value');
    }
    if (this.payload.issue_date != null && !(this.payload.issue_date instanceof Date)) {
      console.error('issue_date must be of type Date');
    }
    if (this.payload.refresh_token_remaining_seconds != null) {
      fixedNumber = canFixNumber(this.payload.refresh_token_remaining_seconds);
      if (fixedNumber === false) {
        console.error('refresh_token_remaining_seconds must be of type Number');
      } else {
        this.payload.refresh_token_remaining_seconds = fixedNumber;
      }
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.time_to_expiration != null && !Object.values(_enum_properties.TimeToExpiration).includes(this.payload.time_to_expiration)) {
      console.error('Invalid time_to_expiration value');
    }
    if (this.payload.token_id != null && !(typeof this.payload.token_id === 'string' || this.payload.token_id instanceof String)) {
      console.error('token_id must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['logout_source', 'access_token_remaining_seconds', 'expiration_date', 'expired_after', 'is_auth_token_different_from_cached', 'issue_date', 'refresh_token_remaining_seconds', 'screen', 'time_to_expiration', 'token_id']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Logout_SucceededProperties = v1_Logout_SucceededProperties;
class v1_MicroDepositConfirmation_ClickedProperties {
  static ExternalAccountConnectionType = {
    microDeposits: 'micro_deposits'
  };
  static ExternalAccountType = {
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['external_account_connection_type', 'external_account_type', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(v1_MicroDepositConfirmation_ClickedProperties.ExternalAccountConnectionType).includes(this.payload.external_account_connection_type)) {
      console.error('Invalid external_account_connection_type value');
    }
    if (!Object.values(v1_MicroDepositConfirmation_ClickedProperties.ExternalAccountType).includes(this.payload.external_account_type)) {
      console.error('Invalid external_account_type value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.externalaccount_id != null && !(typeof this.payload.externalaccount_id === 'string' || this.payload.externalaccount_id instanceof String)) {
      console.error('externalaccount_id must be of type String');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['external_account_connection_type', 'external_account_type', 'screen', 'externalaccount_id', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MicroDepositConfirmation_ClickedProperties = v1_MicroDepositConfirmation_ClickedProperties;
class v1_MicroDepositConfirmation_FailedProperties {
  static ErrorType = {
    validationError: 'validation_error',
    apiError: 'api_error'
  };
  static Reason = {
    exceededAttempts: 'exceeded_attempts',
    incorrectMicros: 'incorrect_micros',
    cannotConfirm: 'cannot_confirm'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['error_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_MicroDepositConfirmation_FailedProperties.ErrorType).includes(this.payload.error_type)) {
      console.error('Invalid error_type value');
    }
    if (this.payload.error_message != null && !(typeof this.payload.error_message === 'string' || this.payload.error_message instanceof String)) {
      console.error('error_message must be of type String');
    }
    if (this.payload.reason != null && !Object.values(v1_MicroDepositConfirmation_FailedProperties.Reason).includes(this.payload.reason)) {
      console.error('Invalid reason value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['error_type', 'error_message', 'reason']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MicroDepositConfirmation_FailedProperties = v1_MicroDepositConfirmation_FailedProperties;
class v1_MicroDepositConfirmation_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['internalaccount_id']);
    var fixedNumber = 0;
    if (!(typeof this.payload.internalaccount_id === 'string' || this.payload.internalaccount_id instanceof String)) {
      console.error('internalaccount_id must be of type String');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['internalaccount_id', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MicroDepositConfirmation_SubmittedProperties = v1_MicroDepositConfirmation_SubmittedProperties;
class v1_MicroDepositConfirmation_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MicroDepositConfirmation_ViewedProperties = v1_MicroDepositConfirmation_ViewedProperties;
class v1_MicroDepositResend_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['internalaccount_id']);
    var fixedNumber = 0;
    if (!(typeof this.payload.internalaccount_id === 'string' || this.payload.internalaccount_id instanceof String)) {
      console.error('internalaccount_id must be of type String');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['internalaccount_id', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MicroDepositResend_SubmittedProperties = v1_MicroDepositResend_SubmittedProperties;
class v1_MoneyMovementConfirmation_ViewedProperties {
  static Destination = {
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira',
    personalBrokerage: 'personal_brokerage',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank',
    externalBank: 'external_bank'
  };
  static Source = {
    externalBank: 'external_bank',
    debitCard: 'debit_card',
    mobileCheck: 'mobile_check',
    eCash: 'e_cash',
    payroll: 'payroll',
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira',
    personalBrokerage: 'personal_brokerage',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static SourceManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'flow_type', 'source']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_MoneyMovementConfirmation_ViewedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(v1_MoneyMovementConfirmation_ViewedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (this.payload.destination_management_type != null && !Object.values(v1_MoneyMovementConfirmation_ViewedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.source_management_type != null && !Object.values(v1_MoneyMovementConfirmation_ViewedProperties.SourceManagementType).includes(this.payload.source_management_type)) {
      console.error('Invalid source_management_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'flow_type', 'source', 'destination_management_type', 'origin', 'source_management_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MoneyMovementConfirmation_ViewedProperties = v1_MoneyMovementConfirmation_ViewedProperties;
class v1_MoneyMovementDestination_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MoneyMovementDestination_ViewedProperties = v1_MoneyMovementDestination_ViewedProperties;
class v1_MoneyMovementLimits_ClickedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank',
    externalBank: 'external_bank',
    debitCard: 'debit_card'
  };
  static Source = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank',
    externalBank: 'external_bank',
    debitCard: 'debit_card'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static SourceManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'screen', 'source']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_MoneyMovementLimits_ClickedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (!Object.values(v1_MoneyMovementLimits_ClickedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (this.payload.destination_management_type != null && !Object.values(v1_MoneyMovementLimits_ClickedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.source_management_type != null && !Object.values(v1_MoneyMovementLimits_ClickedProperties.SourceManagementType).includes(this.payload.source_management_type)) {
      console.error('Invalid source_management_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'screen', 'source', 'destination_management_type', 'flow_type', 'origin', 'source_management_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MoneyMovementLimits_ClickedProperties = v1_MoneyMovementLimits_ClickedProperties;
class v1_MoneyMovementLimits_ViewedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank',
    externalBank: 'external_bank',
    debitCard: 'debit_card'
  };
  static Source = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank',
    externalBank: 'external_bank',
    debitCard: 'debit_card'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static SourceManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'source']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_MoneyMovementLimits_ViewedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(v1_MoneyMovementLimits_ViewedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (this.payload.destination_management_type != null && !Object.values(v1_MoneyMovementLimits_ViewedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.source_management_type != null && !Object.values(v1_MoneyMovementLimits_ViewedProperties.SourceManagementType).includes(this.payload.source_management_type)) {
      console.error('Invalid source_management_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'source', 'destination_management_type', 'flow_type', 'origin', 'source_management_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MoneyMovementLimits_ViewedProperties = v1_MoneyMovementLimits_ViewedProperties;
class v1_MoneyMovementResults_ViewedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank',
    externalBank: 'external_bank',
    debitCard: 'debit_card'
  };
  static Result = {
    succeeded: 'succeeded'
  };
  static Source = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank',
    externalBank: 'external_bank',
    debitCard: 'debit_card'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static SourceManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'frequency_type', 'result', 'source']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_MoneyMovementResults_ViewedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (!Object.values(v1_MoneyMovementResults_ViewedProperties.Result).includes(this.payload.result)) {
      console.error('Invalid result value');
    }
    if (!Object.values(v1_MoneyMovementResults_ViewedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (this.payload.destination_management_type != null && !Object.values(v1_MoneyMovementResults_ViewedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.source_management_type != null && !Object.values(v1_MoneyMovementResults_ViewedProperties.SourceManagementType).includes(this.payload.source_management_type)) {
      console.error('Invalid source_management_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'frequency_type', 'result', 'source', 'destination_management_type', 'flow_type', 'frequency_schedule', 'origin', 'source_management_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MoneyMovementResults_ViewedProperties = v1_MoneyMovementResults_ViewedProperties;
class v1_MoneyMovementSetup_ViewedProperties {
  static Destination = {
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira',
    personalBrokerage: 'personal_brokerage',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank',
    externalBank: 'external_bank'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    externalBank: 'external_bank',
    debitCard: 'debit_card',
    mobileCheck: 'mobile_check',
    eCash: 'e_cash',
    payroll: 'payroll',
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira',
    personalBrokerage: 'personal_brokerage',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank'
  };
  static SourceManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'flow_type', 'frequency_type']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.destination != null && !Object.values(v1_MoneyMovementSetup_ViewedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (this.payload.destination_management_type != null && !Object.values(v1_MoneyMovementSetup_ViewedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.source != null && !Object.values(v1_MoneyMovementSetup_ViewedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (this.payload.source_management_type != null && !Object.values(v1_MoneyMovementSetup_ViewedProperties.SourceManagementType).includes(this.payload.source_management_type)) {
      console.error('Invalid source_management_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'flow_type', 'frequency_type', 'destination', 'destination_management_type', 'frequency_schedule', 'origin', 'source', 'source_management_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MoneyMovementSetup_ViewedProperties = v1_MoneyMovementSetup_ViewedProperties;
class v1_MoneyMovementSource_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MoneyMovementSource_ViewedProperties = v1_MoneyMovementSource_ViewedProperties;
class v1_MoneyMovement_ClickedProperties {
  static Destination = {
    personalBrokerage: 'personal_brokerage',
    bank: 'bank'
  };
  static DestinationManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  static Source = {
    personalBrokerage: 'personal_brokerage',
    traditionalIra: 'traditional_ira',
    rothIra: 'roth_ira',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank',
    externalBank: 'external_bank',
    debitCard: 'debit_card'
  };
  static SourceManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.amount != null) {
      fixedNumber = canFixNumber(this.payload.amount);
      if (fixedNumber === false) {
        console.error('amount must be of type Number');
      } else {
        this.payload.amount = fixedNumber;
      }
    }
    if (this.payload.destination != null && !Object.values(v1_MoneyMovement_ClickedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (this.payload.destination_management_type != null && !Object.values(v1_MoneyMovement_ClickedProperties.DestinationManagementType).includes(this.payload.destination_management_type)) {
      console.error('Invalid destination_management_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.frequency_type != null && !Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.source != null && !Object.values(v1_MoneyMovement_ClickedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (this.payload.source_management_type != null && !Object.values(v1_MoneyMovement_ClickedProperties.SourceManagementType).includes(this.payload.source_management_type)) {
      console.error('Invalid source_management_type value');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'amount', 'destination', 'destination_management_type', 'flow_type', 'frequency_type', 'screen', 'security_ticker', 'source', 'source_management_type', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MoneyMovement_ClickedProperties = v1_MoneyMovement_ClickedProperties;
class v1_MyGoalsModule_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MyGoalsModule_ViewedProperties = v1_MyGoalsModule_ViewedProperties;
class v1_MyStashHomeAccountsSummary_ViewedProperties {
  static FundedType = {
    funded: 'funded',
    unfunded: 'unfunded',
    negativeBalance: 'negative_balance'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['funded_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_MyStashHomeAccountsSummary_ViewedProperties.FundedType).includes(this.payload.funded_type)) {
      console.error('Invalid funded_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['funded_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MyStashHomeAccountsSummary_ViewedProperties = v1_MyStashHomeAccountsSummary_ViewedProperties;
class v1_MyStashHome_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MyStashHome_ClickedProperties = v1_MyStashHome_ClickedProperties;
class v1_MyStashModuleInfo_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MyStashModuleInfo_ClickedProperties = v1_MyStashModuleInfo_ClickedProperties;
class v1_MyStashModule_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['account_type', 'management_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.AccountType).includes(this.payload.account_type)) {
      console.error('Invalid account_type value');
    }
    if (!Object.values(_enum_properties.ManagementType).includes(this.payload.management_type)) {
      console.error('Invalid management_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['account_type', 'management_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MyStashModule_ViewedProperties = v1_MyStashModule_ViewedProperties;
class v1_MyStashSectionFailed_ViewedProperties {
  static Section = {
    accountsSummary: 'accounts_summary'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['section']);
    var fixedNumber = 0;
    if (!Object.values(v1_MyStashSectionFailed_ViewedProperties.Section).includes(this.payload.section)) {
      console.error('Invalid section value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['section']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MyStashSectionFailed_ViewedProperties = v1_MyStashSectionFailed_ViewedProperties;
class v1_MyStashSection_FailedProperties {
  static ErrorType = {
    apiError: 'api_error'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['error_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_MyStashSection_FailedProperties.ErrorType).includes(this.payload.error_type)) {
      console.error('Invalid error_type value');
    }
    if (this.payload.error_code != null && !(typeof this.payload.error_code === 'string' || this.payload.error_code instanceof String)) {
      console.error('error_code must be of type String');
    }
    if (this.payload.error_message != null && !(typeof this.payload.error_message === 'string' || this.payload.error_message instanceof String)) {
      console.error('error_message must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['error_type', 'error_code', 'error_message']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_MyStashSection_FailedProperties = v1_MyStashSection_FailedProperties;
class v1_OfferAccepted_ClickedProperties {
  static OfferType = {
    retention: 'retention'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'offer_id', 'offer_name', 'offer_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!(typeof this.payload.offer_id === 'string' || this.payload.offer_id instanceof String)) {
      console.error('offer_id must be of type String');
    }
    if (!(typeof this.payload.offer_name === 'string' || this.payload.offer_name instanceof String)) {
      console.error('offer_name must be of type String');
    }
    if (!Object.values(v1_OfferAccepted_ClickedProperties.OfferType).includes(this.payload.offer_type)) {
      console.error('Invalid offer_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'offer_id', 'offer_name', 'offer_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_OfferAccepted_ClickedProperties = v1_OfferAccepted_ClickedProperties;
class v1_Offer_ViewedProperties {
  static OfferType = {
    retention: 'retention'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'offer_id', 'offer_name', 'offer_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!(typeof this.payload.offer_id === 'string' || this.payload.offer_id instanceof String)) {
      console.error('offer_id must be of type String');
    }
    if (!(typeof this.payload.offer_name === 'string' || this.payload.offer_name instanceof String)) {
      console.error('offer_name must be of type String');
    }
    if (!Object.values(v1_Offer_ViewedProperties.OfferType).includes(this.payload.offer_type)) {
      console.error('Invalid offer_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'offer_id', 'offer_name', 'offer_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Offer_ViewedProperties = v1_Offer_ViewedProperties;
class v1_OtherAccountsInfo_ClickedProperties {
  static GoalHorizon = {
    shortTerm: 'short_term',
    longTerm: 'long_term'
  };
  static GoalType = {
    custom: 'custom'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['goal_horizon', 'goal_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(v1_OtherAccountsInfo_ClickedProperties.GoalHorizon).includes(this.payload.goal_horizon)) {
      console.error('Invalid goal_horizon value');
    }
    if (!Object.values(v1_OtherAccountsInfo_ClickedProperties.GoalType).includes(this.payload.goal_type)) {
      console.error('Invalid goal_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['goal_horizon', 'goal_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_OtherAccountsInfo_ClickedProperties = v1_OtherAccountsInfo_ClickedProperties;
class v1_PIIEntry_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PIIEntry_SubmittedProperties = v1_PIIEntry_SubmittedProperties;
class v1_PIIEntry_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PIIEntry_ViewedProperties = v1_PIIEntry_ViewedProperties;
class v1_PersonalDetailsEntry_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'flow_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PersonalDetailsEntry_ViewedProperties = v1_PersonalDetailsEntry_ViewedProperties;
class v1_PersonalDetails_SubmittedProperties {
  static CitizenshipStatus = {
    usCitizen: 'us_citizen',
    permanentResident: 'permanent_resident',
    visa: 'visa',
    other: 'other'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['citizenship_status']);
    var fixedNumber = 0;
    if (!Object.values(v1_PersonalDetails_SubmittedProperties.CitizenshipStatus).includes(this.payload.citizenship_status)) {
      console.error('Invalid citizenship_status value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['citizenship_status', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PersonalDetails_SubmittedProperties = v1_PersonalDetails_SubmittedProperties;
class v1_PersonalPick_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PersonalPick_ClickedProperties = v1_PersonalPick_ClickedProperties;
class v1_PersonalPortfolioInfo_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PersonalPortfolioInfo_ClickedProperties = v1_PersonalPortfolioInfo_ClickedProperties;
class v1_PhoneEntry_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PhoneEntry_ViewedProperties = v1_PhoneEntry_ViewedProperties;
class v1_PhoneOTPResend_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PhoneOTPResend_ClickedProperties = v1_PhoneOTPResend_ClickedProperties;
class v1_PhoneOTPResend_FailedProperties {
  static ErrorType = {
    apiError: 'api_error',
    validationError: 'validation_error'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.error_type != null && !Object.values(v1_PhoneOTPResend_FailedProperties.ErrorType).includes(this.payload.error_type)) {
      console.error('Invalid error_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['error_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PhoneOTPResend_FailedProperties = v1_PhoneOTPResend_FailedProperties;
class v1_PhoneOTPResend_SubmittedProperties {
  static ResendType = {
    call: 'call',
    text: 'text'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin', 'resend_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_PhoneOTPResend_SubmittedProperties.ResendType).includes(this.payload.resend_type)) {
      console.error('Invalid resend_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'resend_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PhoneOTPResend_SubmittedProperties = v1_PhoneOTPResend_SubmittedProperties;
class v1_PhoneOTPResend_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PhoneOTPResend_ViewedProperties = v1_PhoneOTPResend_ViewedProperties;
class v1_PhoneOTP_FailedProperties {
  static ErrorType = {
    apiError: 'api_error',
    validationError: 'validation_error'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.error_type != null && !Object.values(v1_PhoneOTP_FailedProperties.ErrorType).includes(this.payload.error_type)) {
      console.error('Invalid error_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['error_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PhoneOTP_FailedProperties = v1_PhoneOTP_FailedProperties;
class v1_PhoneOTP_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'flow_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PhoneOTP_SubmittedProperties = v1_PhoneOTP_SubmittedProperties;
class v1_PhoneVerification_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'flow_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PhoneVerification_ViewedProperties = v1_PhoneVerification_ViewedProperties;
class v1_Phone_FailedProperties {
  static ErrorType = {
    apiError: 'api_error',
    validationError: 'validation_error'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.error_type != null && !Object.values(v1_Phone_FailedProperties.ErrorType).includes(this.payload.error_type)) {
      console.error('Invalid error_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['error_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Phone_FailedProperties = v1_Phone_FailedProperties;
class v1_Phone_SubmittedProperties {
  static CheckedMarketingOptIn = {
    yes: 'yes',
    no: 'no'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.checked_marketing_opt_in != null && !Object.values(v1_Phone_SubmittedProperties.CheckedMarketingOptIn).includes(this.payload.checked_marketing_opt_in)) {
      console.error('Invalid checked_marketing_opt_in value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'checked_marketing_opt_in']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Phone_SubmittedProperties = v1_Phone_SubmittedProperties;
class v1_PortfolioDetails_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['account_type', 'management_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.AccountType).includes(this.payload.account_type)) {
      console.error('Invalid account_type value');
    }
    if (!Object.values(_enum_properties.ManagementType).includes(this.payload.management_type)) {
      console.error('Invalid management_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['account_type', 'management_type', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PortfolioDetails_ViewedProperties = v1_PortfolioDetails_ViewedProperties;
class v1_PortfolioOverview_ClickedProperties {
  static PortfolioType = {
    conservative: 'conservative',
    moderate: 'moderate',
    aggressive: 'aggressive'
  };
  static ButtonLocation = {
    portfolioIcon: 'portfolio_icon',
    primaryButton: 'primary_button'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin', 'portfolio_type', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_PortfolioOverview_ClickedProperties.PortfolioType).includes(this.payload.portfolio_type)) {
      console.error('Invalid portfolio_type value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.button_location != null && !Object.values(v1_PortfolioOverview_ClickedProperties.ButtonLocation).includes(this.payload.button_location)) {
      console.error('Invalid button_location value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'portfolio_type', 'screen', 'button_location']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PortfolioOverview_ClickedProperties = v1_PortfolioOverview_ClickedProperties;
class v1_PortfolioOverview_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PortfolioOverview_ViewedProperties = v1_PortfolioOverview_ViewedProperties;
class v1_PortfolioSetupPrimer_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PortfolioSetupPrimer_ClickedProperties = v1_PortfolioSetupPrimer_ClickedProperties;
class v1_PortfolioSetupPrimer_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PortfolioSetupPrimer_ViewedProperties = v1_PortfolioSetupPrimer_ViewedProperties;
class v1_PortfolioSetup_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'management_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.ManagementType).includes(this.payload.management_type)) {
      console.error('Invalid management_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'management_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PortfolioSetup_ClickedProperties = v1_PortfolioSetup_ClickedProperties;
class v1_PreferredPaymentMethod_SubmittedProperties {
  static ExternalAccountType = {
    creditDebit: 'credit_debit',
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['external_account_type', 'flow_type', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(v1_PreferredPaymentMethod_SubmittedProperties.ExternalAccountType).includes(this.payload.external_account_type)) {
      console.error('Invalid external_account_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['external_account_type', 'flow_type', 'origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_PreferredPaymentMethod_SubmittedProperties = v1_PreferredPaymentMethod_SubmittedProperties;
class v1_ProductHighlightsModule_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['content_card', 'origin']);
    var fixedNumber = 0;
    if (!(typeof this.payload.content_card === 'string' || this.payload.content_card instanceof String)) {
      console.error('content_card must be of type String');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['content_card', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ProductHighlightsModule_ClickedProperties = v1_ProductHighlightsModule_ClickedProperties;
class v1_ProductHighlightsModule_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ProductHighlightsModule_ViewedProperties = v1_ProductHighlightsModule_ViewedProperties;
class v1_ReactivateSubscription_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['screen', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ReactivateSubscription_ClickedProperties = v1_ReactivateSubscription_ClickedProperties;
class v1_ReactivationEntry_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ReactivationEntry_SubmittedProperties = v1_ReactivationEntry_SubmittedProperties;
class v1_ReactivationEntry_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ReactivationEntry_ViewedProperties = v1_ReactivationEntry_ViewedProperties;
class v1_ReactivationEsig_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ReactivationEsig_SubmittedProperties = v1_ReactivationEsig_SubmittedProperties;
class v1_ReactivationEsig_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ReactivationEsig_ViewedProperties = v1_ReactivationEsig_ViewedProperties;
class v1_RecurringTransactionAuthorization_SubmittedProperties {
  static ExternalAccountConnectionType = {
    instant: 'instant',
    microDeposits: 'micro_deposits'
  };
  static ExternalAccountType = {
    bank: 'bank',
    creditDebit: 'credit_debit'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['external_account_connection_type', 'external_account_type', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(v1_RecurringTransactionAuthorization_SubmittedProperties.ExternalAccountConnectionType).includes(this.payload.external_account_connection_type)) {
      console.error('Invalid external_account_connection_type value');
    }
    if (!Object.values(v1_RecurringTransactionAuthorization_SubmittedProperties.ExternalAccountType).includes(this.payload.external_account_type)) {
      console.error('Invalid external_account_type value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.authorized != null && !(typeof this.payload.authorized === 'string' || this.payload.authorized instanceof String)) {
      console.error('authorized must be of type String');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.not_authorized != null && !(typeof this.payload.not_authorized === 'string' || this.payload.not_authorized instanceof String)) {
      console.error('not_authorized must be of type String');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['external_account_connection_type', 'external_account_type', 'screen', 'authorized', 'flow_type', 'not_authorized', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_RecurringTransactionAuthorization_SubmittedProperties = v1_RecurringTransactionAuthorization_SubmittedProperties;
class v1_RecurringTransactionAuthorization_ViewedProperties {
  static ExternalAccountConnectionType = {
    instant: 'instant',
    microDeposits: 'micro_deposits'
  };
  static ExternalAccountType = {
    bank: 'bank'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['external_account_connection_type', 'external_account_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_RecurringTransactionAuthorization_ViewedProperties.ExternalAccountConnectionType).includes(this.payload.external_account_connection_type)) {
      console.error('Invalid external_account_connection_type value');
    }
    if (!Object.values(v1_RecurringTransactionAuthorization_ViewedProperties.ExternalAccountType).includes(this.payload.external_account_type)) {
      console.error('Invalid external_account_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['external_account_connection_type', 'external_account_type', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_RecurringTransactionAuthorization_ViewedProperties = v1_RecurringTransactionAuthorization_ViewedProperties;
class v1_ReferralHome_ClickedProperties {
  static Results = {
    success: 'success'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.results != null && !Object.values(v1_ReferralHome_ClickedProperties.Results).includes(this.payload.results)) {
      console.error('Invalid results value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'flow_type', 'results', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ReferralHome_ClickedProperties = v1_ReferralHome_ClickedProperties;
class v1_ReferralHome_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.campaign_name != null && !(typeof this.payload.campaign_name === 'string' || this.payload.campaign_name instanceof String)) {
      console.error('campaign_name must be of type String');
    }
    if (this.payload.campaign_tag != null && !(typeof this.payload.campaign_tag === 'string' || this.payload.campaign_tag instanceof String)) {
      console.error('campaign_tag must be of type String');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.recipient_amount != null) {
      fixedNumber = canFixNumber(this.payload.recipient_amount);
      if (fixedNumber === false) {
        console.error('recipient_amount must be of type Number');
      } else {
        this.payload.recipient_amount = fixedNumber;
      }
    }
    if (this.payload.sender_amount != null) {
      fixedNumber = canFixNumber(this.payload.sender_amount);
      if (fixedNumber === false) {
        console.error('sender_amount must be of type Number');
      } else {
        this.payload.sender_amount = fixedNumber;
      }
    }
    if (this.payload.t1_campaign_id != null && !(typeof this.payload.t1_campaign_id === 'string' || this.payload.t1_campaign_id instanceof String)) {
      console.error('t1_campaign_id must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['campaign_name', 'campaign_tag', 'origin', 'recipient_amount', 'sender_amount', 't1_campaign_id']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ReferralHome_ViewedProperties = v1_ReferralHome_ViewedProperties;
class v1_ReferralLandingPage_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['referral_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.ReferralType).includes(this.payload.referral_type)) {
      console.error('Invalid referral_type value');
    }
    if (this.payload.campaign_id != null && !(typeof this.payload.campaign_id === 'string' || this.payload.campaign_id instanceof String)) {
      console.error('campaign_id must be of type String');
    }
    if (this.payload.campaign_name != null && !(typeof this.payload.campaign_name === 'string' || this.payload.campaign_name instanceof String)) {
      console.error('campaign_name must be of type String');
    }
    if (this.payload.expiration_date != null && !(typeof this.payload.expiration_date === 'string' || this.payload.expiration_date instanceof String)) {
      console.error('expiration_date must be of type String');
    }
    if (this.payload.share_code != null && !(typeof this.payload.share_code === 'string' || this.payload.share_code instanceof String)) {
      console.error('share_code must be of type String');
    }
    if (this.payload.variant != null && !(typeof this.payload.variant === 'string' || this.payload.variant instanceof String)) {
      console.error('variant must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['referral_type', 'campaign_id', 'campaign_name', 'expiration_date', 'share_code', 'variant']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ReferralLandingPage_ClickedProperties = v1_ReferralLandingPage_ClickedProperties;
class v1_ReferralLandingPage_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'referral_type']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!Object.values(_enum_properties.ReferralType).includes(this.payload.referral_type)) {
      console.error('Invalid referral_type value');
    }
    if (this.payload.campaign_id != null && !(typeof this.payload.campaign_id === 'string' || this.payload.campaign_id instanceof String)) {
      console.error('campaign_id must be of type String');
    }
    if (this.payload.campaign_name != null && !(typeof this.payload.campaign_name === 'string' || this.payload.campaign_name instanceof String)) {
      console.error('campaign_name must be of type String');
    }
    if (this.payload.expiration_date != null && !(typeof this.payload.expiration_date === 'string' || this.payload.expiration_date instanceof String)) {
      console.error('expiration_date must be of type String');
    }
    if (this.payload.share_code != null && !(typeof this.payload.share_code === 'string' || this.payload.share_code instanceof String)) {
      console.error('share_code must be of type String');
    }
    if (this.payload.variant != null && !(typeof this.payload.variant === 'string' || this.payload.variant instanceof String)) {
      console.error('variant must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'referral_type', 'campaign_id', 'campaign_name', 'expiration_date', 'share_code', 'variant']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ReferralLandingPage_ViewedProperties = v1_ReferralLandingPage_ViewedProperties;
class v1_ReferralModule_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.learn_id != null && !(typeof this.payload.learn_id === 'string' || this.payload.learn_id instanceof String)) {
      console.error('learn_id must be of type String');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
    if (this.payload.title != null && !(typeof this.payload.title === 'string' || this.payload.title instanceof String)) {
      console.error('title must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'screen', 'learn_id', 'security_ticker', 'ticker_symbol', 'title']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ReferralModule_ClickedProperties = v1_ReferralModule_ClickedProperties;
class v1_ReferralModule_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'screen', 'security_ticker', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ReferralModule_ViewedProperties = v1_ReferralModule_ViewedProperties;
class v1_ReferralShareCode_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['share_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.ShareType).includes(this.payload.share_type)) {
      console.error('Invalid share_type value');
    }
    if (this.payload.campaign_id != null && !(typeof this.payload.campaign_id === 'string' || this.payload.campaign_id instanceof String)) {
      console.error('campaign_id must be of type String');
    }
    if (this.payload.campaign_name != null && !(typeof this.payload.campaign_name === 'string' || this.payload.campaign_name instanceof String)) {
      console.error('campaign_name must be of type String');
    }
    if (this.payload.expiration_date != null && !(typeof this.payload.expiration_date === 'string' || this.payload.expiration_date instanceof String)) {
      console.error('expiration_date must be of type String');
    }
    if (this.payload.party_id != null && !(typeof this.payload.party_id === 'string' || this.payload.party_id instanceof String)) {
      console.error('party_id must be of type String');
    }
    if (this.payload.referral_source != null && !Object.values(_enum_properties.ReferralSource).includes(this.payload.referral_source)) {
      console.error('Invalid referral_source value');
    }
    if (this.payload.referral_type != null && !Object.values(_enum_properties.ReferralType).includes(this.payload.referral_type)) {
      console.error('Invalid referral_type value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.share_code != null && !(typeof this.payload.share_code === 'string' || this.payload.share_code instanceof String)) {
      console.error('share_code must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
    if (this.payload.variant != null && !(typeof this.payload.variant === 'string' || this.payload.variant instanceof String)) {
      console.error('variant must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['share_type', 'campaign_id', 'campaign_name', 'expiration_date', 'party_id', 'referral_source', 'referral_type', 'screen', 'security_ticker', 'share_code', 'ticker_symbol', 'variant']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ReferralShareCode_ClickedProperties = v1_ReferralShareCode_ClickedProperties;
class v1_ResumeAutoStashModule_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'screen', 'security_ticker', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ResumeAutoStashModule_ClickedProperties = v1_ResumeAutoStashModule_ClickedProperties;
class v1_ResumeAutoStashModule_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'screen', 'security_ticker', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ResumeAutoStashModule_ViewedProperties = v1_ResumeAutoStashModule_ViewedProperties;
class v1_RetirementDistributionForm_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_RetirementDistributionForm_ClickedProperties = v1_RetirementDistributionForm_ClickedProperties;
class v1_RetirementHome_ClickedProperties {
  static RetirementType = {
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.account_type != null && !Object.values(_enum_properties.AccountType).includes(this.payload.account_type)) {
      console.error('Invalid account_type value');
    }
    if (this.payload.retirement_type != null && !Object.values(v1_RetirementHome_ClickedProperties.RetirementType).includes(this.payload.retirement_type)) {
      console.error('Invalid retirement_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen', 'account_type', 'retirement_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_RetirementHome_ClickedProperties = v1_RetirementHome_ClickedProperties;
class v1_RewardsCenterModule_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_RewardsCenterModule_ClickedProperties = v1_RewardsCenterModule_ClickedProperties;
class v1_RewardsCenterModule_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_RewardsCenterModule_ViewedProperties = v1_RewardsCenterModule_ViewedProperties;
class v1_RewardsCenter_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_RewardsCenter_ViewedProperties = v1_RewardsCenter_ViewedProperties;
class v1_SSNEntry_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'flow_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SSNEntry_ViewedProperties = v1_SSNEntry_ViewedProperties;
class v1_SSN_FailedProperties {
  static ErrorType = {
    apiError: 'api_error',
    validationError: 'validation_error'
  };
  static Reason = {
    alreadyExists: 'already_exists'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.error_message != null && !(typeof this.payload.error_message === 'string' || this.payload.error_message instanceof String)) {
      console.error('error_message must be of type String');
    }
    if (this.payload.error_type != null && !Object.values(v1_SSN_FailedProperties.ErrorType).includes(this.payload.error_type)) {
      console.error('Invalid error_type value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.reason != null && !Object.values(v1_SSN_FailedProperties.Reason).includes(this.payload.reason)) {
      console.error('Invalid reason value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['error_message', 'error_type', 'flow_type', 'origin', 'reason']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SSN_FailedProperties = v1_SSN_FailedProperties;
class v1_SSN_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'flow_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SSN_SubmittedProperties = v1_SSN_SubmittedProperties;
class v1_SSN_SucceededProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SSN_SucceededProperties = v1_SSN_SucceededProperties;
class v1_SecurityDetails_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen', 'security_ticker', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SecurityDetails_ClickedProperties = v1_SecurityDetails_ClickedProperties;
class v1_ShareReferral_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.variant != null && !(typeof this.payload.variant === 'string' || this.payload.variant instanceof String)) {
      console.error('variant must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'variant']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_ShareReferral_ViewedProperties = v1_ShareReferral_ViewedProperties;
class v1_SmartDeposit_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['account_type', 'management_type', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.AccountType).includes(this.payload.account_type)) {
      console.error('Invalid account_type value');
    }
    if (!Object.values(_enum_properties.ManagementType).includes(this.payload.management_type)) {
      console.error('Invalid management_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['account_type', 'management_type', 'origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SmartDeposit_ClickedProperties = v1_SmartDeposit_ClickedProperties;
class v1_SmartMixInfo_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SmartMixInfo_ClickedProperties = v1_SmartMixInfo_ClickedProperties;
class v1_SpecialOffers_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SpecialOffers_ClickedProperties = v1_SpecialOffers_ClickedProperties;
class v1_Sso_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['sso_provider']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.SsoProvider).includes(this.payload.sso_provider)) {
      console.error('Invalid sso_provider value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['sso_provider']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Sso_ClickedProperties = v1_Sso_ClickedProperties;
class v1_Sso_FailedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['sso_provider']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.SsoProvider).includes(this.payload.sso_provider)) {
      console.error('Invalid sso_provider value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['sso_provider']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Sso_FailedProperties = v1_Sso_FailedProperties;
class v1_Sso_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['sso_provider']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.SsoProvider).includes(this.payload.sso_provider)) {
      console.error('Invalid sso_provider value');
    }
    if (this.payload.utm_campaign != null && !(typeof this.payload.utm_campaign === 'string' || this.payload.utm_campaign instanceof String)) {
      console.error('utm_campaign must be of type String');
    }
    if (this.payload.utm_content != null && !(typeof this.payload.utm_content === 'string' || this.payload.utm_content instanceof String)) {
      console.error('utm_content must be of type String');
    }
    if (this.payload.utm_medium != null && !(typeof this.payload.utm_medium === 'string' || this.payload.utm_medium instanceof String)) {
      console.error('utm_medium must be of type String');
    }
    if (this.payload.utm_source != null && !(typeof this.payload.utm_source === 'string' || this.payload.utm_source instanceof String)) {
      console.error('utm_source must be of type String');
    }
    if (this.payload.utm_term != null && !(typeof this.payload.utm_term === 'string' || this.payload.utm_term instanceof String)) {
      console.error('utm_term must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['sso_provider', 'utm_campaign', 'utm_content', 'utm_medium', 'utm_source', 'utm_term']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_Sso_SubmittedProperties = v1_Sso_SubmittedProperties;
class v1_StashWorksUserSignup_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_StashWorksUserSignup_ClickedProperties = v1_StashWorksUserSignup_ClickedProperties;
class v1_StashWorksUserSignup_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_StashWorksUserSignup_SubmittedProperties = v1_StashWorksUserSignup_SubmittedProperties;
class v1_StashWorksUserSignup_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.eid != null && !(typeof this.payload.eid === 'string' || this.payload.eid instanceof String)) {
      console.error('eid must be of type String');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.source != null && !(typeof this.payload.source === 'string' || this.payload.source instanceof String)) {
      console.error('source must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['eid', 'flow_type', 'origin', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_StashWorksUserSignup_ViewedProperties = v1_StashWorksUserSignup_ViewedProperties;
class v1_StashWorksWelcomeScreen_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['employer_name']);
    var fixedNumber = 0;
    if (!(typeof this.payload.employer_name === 'string' || this.payload.employer_name instanceof String)) {
      console.error('employer_name must be of type String');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['employer_name', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_StashWorksWelcomeScreen_SubmittedProperties = v1_StashWorksWelcomeScreen_SubmittedProperties;
class v1_StashWorksWelcomeScreen_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.eid != null && !(typeof this.payload.eid === 'string' || this.payload.eid instanceof String)) {
      console.error('eid must be of type String');
    }
    if (this.payload.employer_name != null && !(typeof this.payload.employer_name === 'string' || this.payload.employer_name instanceof String)) {
      console.error('employer_name must be of type String');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.source != null && !(typeof this.payload.source === 'string' || this.payload.source instanceof String)) {
      console.error('source must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'eid', 'employer_name', 'flow_type', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_StashWorksWelcomeScreen_ViewedProperties = v1_StashWorksWelcomeScreen_ViewedProperties;
class v1_StashWorks_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_StashWorks_ClickedProperties = v1_StashWorks_ClickedProperties;
class v1_StateZero_ViewedProperties {
  static Variation = {
    smartDefault: 'smart_default',
    stateZeroPrimer: 'state_zero_primer'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.variation != null && !Object.values(v1_StateZero_ViewedProperties.Variation).includes(this.payload.variation)) {
      console.error('Invalid variation value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'variation']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_StateZero_ViewedProperties = v1_StateZero_ViewedProperties;
class v1_StockBackHome_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_StockBackHome_ClickedProperties = v1_StockBackHome_ClickedProperties;
class v1_StockBackHome_ViewedProperties {
  static Variation = {
    active: 'active',
    inactive: 'inactive'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin', 'variation']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_StockBackHome_ViewedProperties.Variation).includes(this.payload.variation)) {
      console.error('Invalid variation value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'variation']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_StockBackHome_ViewedProperties = v1_StockBackHome_ViewedProperties;
class v1_StockBackReward_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_StockBackReward_SubmittedProperties = v1_StockBackReward_SubmittedProperties;
class v1_StockBackReward_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_StockBackReward_ViewedProperties = v1_StockBackReward_ViewedProperties;
class v1_StockBackRoundups_SubmittedProperties {
  static Change = {
    enable: 'enable',
    disable: 'disable'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['change', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(v1_StockBackRoundups_SubmittedProperties.Change).includes(this.payload.change)) {
      console.error('Invalid change value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['change', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_StockBackRoundups_SubmittedProperties = v1_StockBackRoundups_SubmittedProperties;
class v1_StockBackRoundups_ViewedProperties {
  static Variation = {
    active: 'active',
    inactive: 'inactive'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin', 'variation']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_StockBackRoundups_ViewedProperties.Variation).includes(this.payload.variation)) {
      console.error('Invalid variation value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'variation']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_StockBackRoundups_ViewedProperties = v1_StockBackRoundups_ViewedProperties;
class v1_StockPartyClaim_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.party_id != null && !(typeof this.payload.party_id === 'string' || this.payload.party_id instanceof String)) {
      console.error('party_id must be of type String');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'party_id', 'screen', 'security_ticker', 'ticker_symbol']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_StockPartyClaim_ClickedProperties = v1_StockPartyClaim_ClickedProperties;
class v1_StockParty_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_StockParty_ClickedProperties = v1_StockParty_ClickedProperties;
class v1_StockParty_ViewedProperties {
  static UserState = {
    unauthenticated: 'unauthenticated'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.party_id != null && !(typeof this.payload.party_id === 'string' || this.payload.party_id instanceof String)) {
      console.error('party_id must be of type String');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
    if (this.payload.security_ticker != null && !(typeof this.payload.security_ticker === 'string' || this.payload.security_ticker instanceof String)) {
      console.error('security_ticker must be of type String');
    }
    if (this.payload.ticker_symbol != null && !(typeof this.payload.ticker_symbol === 'string' || this.payload.ticker_symbol instanceof String)) {
      console.error('ticker_symbol must be of type String');
    }
    if (this.payload.user_state != null && !Object.values(v1_StockParty_ViewedProperties.UserState).includes(this.payload.user_state)) {
      console.error('Invalid user_state value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'party_id', 'screen', 'security_ticker', 'ticker_symbol', 'user_state']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_StockParty_ViewedProperties = v1_StockParty_ViewedProperties;
class v1_SubscriptionBillingFrequency_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.billing_frequency != null && !Object.values(_enum_properties.BillingFrequency).includes(this.payload.billing_frequency)) {
      console.error('Invalid billing_frequency value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'billing_frequency']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SubscriptionBillingFrequency_ClickedProperties = v1_SubscriptionBillingFrequency_ClickedProperties;
class v1_SubscriptionBillingFrequency_SubmittedProperties {
  static PageVersion = {
    oldTier: 'old_tier',
    pilotPlan: 'pilot_plan'
  };
  static TierPlan = {
    growth: 'growth',
    stashplus: 'stashplus'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['billing_frequency', 'origin', 'plan_price_amount', 'plan_price_currency']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.BillingFrequency).includes(this.payload.billing_frequency)) {
      console.error('Invalid billing_frequency value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    fixedNumber = canFixNumber(this.payload.plan_price_amount);
    if (fixedNumber === false) {
      console.error('plan_price_amount must be of type Number');
    } else {
      this.payload.plan_price_amount = fixedNumber;
    }
    if (!(typeof this.payload.plan_price_currency === 'string' || this.payload.plan_price_currency instanceof String)) {
      console.error('plan_price_currency must be of type String');
    }
    if (this.payload.discount != null) {
      fixedNumber = canFixNumber(this.payload.discount);
      if (fixedNumber === false) {
        console.error('discount must be of type Number');
      } else {
        this.payload.discount = fixedNumber;
      }
    }
    if (this.payload.page_version != null && !Object.values(v1_SubscriptionBillingFrequency_SubmittedProperties.PageVersion).includes(this.payload.page_version)) {
      console.error('Invalid page_version value');
    }
    if (this.payload.tier_plan != null && !Object.values(v1_SubscriptionBillingFrequency_SubmittedProperties.TierPlan).includes(this.payload.tier_plan)) {
      console.error('Invalid tier_plan value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['billing_frequency', 'origin', 'plan_price_amount', 'plan_price_currency', 'discount', 'page_version', 'tier_plan']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SubscriptionBillingFrequency_SubmittedProperties = v1_SubscriptionBillingFrequency_SubmittedProperties;
class v1_SubscriptionBillingFrequency_ViewedProperties {
  static PageVersion = {
    oldTier: 'old_tier',
    pilotPlan: 'pilot_plan'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.page_version != null && !Object.values(v1_SubscriptionBillingFrequency_ViewedProperties.PageVersion).includes(this.payload.page_version)) {
      console.error('Invalid page_version value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'flow_type', 'page_version']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SubscriptionBillingFrequency_ViewedProperties = v1_SubscriptionBillingFrequency_ViewedProperties;
class v1_SubscriptionCancelContinue_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SubscriptionCancelContinue_ClickedProperties = v1_SubscriptionCancelContinue_ClickedProperties;
class v1_SubscriptionCancel_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SubscriptionCancel_ClickedProperties = v1_SubscriptionCancel_ClickedProperties;
class v1_SubscriptionDetails_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin', 'screen']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SubscriptionDetails_ClickedProperties = v1_SubscriptionDetails_ClickedProperties;
class v1_SubscriptionDetails_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SubscriptionDetails_ViewedProperties = v1_SubscriptionDetails_ViewedProperties;
class v1_SubscriptionPaymentMethod_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SubscriptionPaymentMethod_ViewedProperties = v1_SubscriptionPaymentMethod_ViewedProperties;
class v1_SubscriptionPlanConfirm_ViewedProperties {
  static TierPlan = {
    growth: 'growth',
    stashplus: 'stashplus'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin', 'tier_plan']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_SubscriptionPlanConfirm_ViewedProperties.TierPlan).includes(this.payload.tier_plan)) {
      console.error('Invalid tier_plan value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'tier_plan']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SubscriptionPlanConfirm_ViewedProperties = v1_SubscriptionPlanConfirm_ViewedProperties;
class v1_SubscriptionPlanDetails_ClickedProperties {
  static TierPlan = {
    growth: 'growth',
    stashplus: 'stashplus'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['billing_frequency', 'flow_type', 'origin', 'tier_plan']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.BillingFrequency).includes(this.payload.billing_frequency)) {
      console.error('Invalid billing_frequency value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_SubscriptionPlanDetails_ClickedProperties.TierPlan).includes(this.payload.tier_plan)) {
      console.error('Invalid tier_plan value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['billing_frequency', 'flow_type', 'origin', 'tier_plan']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SubscriptionPlanDetails_ClickedProperties = v1_SubscriptionPlanDetails_ClickedProperties;
class v1_SubscriptionPlanDetails_ViewedProperties {
  static TierPlan = {
    growth: 'growth',
    stashplus: 'stashplus'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['billing_frequency', 'flow_type', 'origin', 'tier_plan']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.BillingFrequency).includes(this.payload.billing_frequency)) {
      console.error('Invalid billing_frequency value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_SubscriptionPlanDetails_ViewedProperties.TierPlan).includes(this.payload.tier_plan)) {
      console.error('Invalid tier_plan value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['billing_frequency', 'flow_type', 'origin', 'tier_plan']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SubscriptionPlanDetails_ViewedProperties = v1_SubscriptionPlanDetails_ViewedProperties;
class v1_SubscriptionPlanNextSteps_ViewedProperties {
  static TierPlan = {
    growth: 'growth',
    stashplus: 'stashplus'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin', 'tier_plan']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_SubscriptionPlanNextSteps_ViewedProperties.TierPlan).includes(this.payload.tier_plan)) {
      console.error('Invalid tier_plan value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'tier_plan']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SubscriptionPlanNextSteps_ViewedProperties = v1_SubscriptionPlanNextSteps_ViewedProperties;
class v1_SubscriptionPlanRefund_ViewedProperties {
  static Variation = {
    subscriptionChange: 'subscription_change',
    billingFrequencyChange: 'billing_frequency_change'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin', 'variation']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_SubscriptionPlanRefund_ViewedProperties.Variation).includes(this.payload.variation)) {
      console.error('Invalid variation value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'variation']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SubscriptionPlanRefund_ViewedProperties = v1_SubscriptionPlanRefund_ViewedProperties;
class v1_SubscriptionPlan_ClickedProperties {
  static TierPlan = {
    growth: 'growth',
    stashplus: 'stashplus'
  };
  static PageVersion = {
    oldTier: 'old_tier',
    pilotPlan: 'pilot_plan'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin', 'tier_plan']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_SubscriptionPlan_ClickedProperties.TierPlan).includes(this.payload.tier_plan)) {
      console.error('Invalid tier_plan value');
    }
    if (this.payload.page_version != null && !Object.values(v1_SubscriptionPlan_ClickedProperties.PageVersion).includes(this.payload.page_version)) {
      console.error('Invalid page_version value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'tier_plan', 'page_version']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SubscriptionPlan_ClickedProperties = v1_SubscriptionPlan_ClickedProperties;
class v1_SubscriptionPlan_SubmittedProperties {
  static TierPlan = {
    growth: 'growth',
    stashplus: 'stashplus'
  };
  static PageVersion = {
    oldTier: 'old_tier',
    pilotPlan: 'pilot_plan'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin', 'tier_plan']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!Object.values(v1_SubscriptionPlan_SubmittedProperties.TierPlan).includes(this.payload.tier_plan)) {
      console.error('Invalid tier_plan value');
    }
    if (this.payload.billing_frequency != null && !Object.values(_enum_properties.BillingFrequency).includes(this.payload.billing_frequency)) {
      console.error('Invalid billing_frequency value');
    }
    if (this.payload.page_version != null && !Object.values(v1_SubscriptionPlan_SubmittedProperties.PageVersion).includes(this.payload.page_version)) {
      console.error('Invalid page_version value');
    }
    if (this.payload.plan_price_amount != null) {
      fixedNumber = canFixNumber(this.payload.plan_price_amount);
      if (fixedNumber === false) {
        console.error('plan_price_amount must be of type Number');
      } else {
        this.payload.plan_price_amount = fixedNumber;
      }
    }
    if (this.payload.plan_price_currency != null && !(typeof this.payload.plan_price_currency === 'string' || this.payload.plan_price_currency instanceof String)) {
      console.error('plan_price_currency must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'tier_plan', 'billing_frequency', 'page_version', 'plan_price_amount', 'plan_price_currency']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SubscriptionPlan_SubmittedProperties = v1_SubscriptionPlan_SubmittedProperties;
class v1_SubscriptionPlan_ViewedProperties {
  static PageVersion = {
    oldTier: 'old_tier',
    pilotPlan: 'pilot_plan'
  };
  static Variation = {
    stashworks: 'stashworks'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.page_version != null && !Object.values(v1_SubscriptionPlan_ViewedProperties.PageVersion).includes(this.payload.page_version)) {
      console.error('Invalid page_version value');
    }
    if (this.payload.variation != null && !Object.values(v1_SubscriptionPlan_ViewedProperties.Variation).includes(this.payload.variation)) {
      console.error('Invalid variation value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'page_version', 'variation']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_SubscriptionPlan_ViewedProperties = v1_SubscriptionPlan_ViewedProperties;
class v1_TotalValueInfo_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_TotalValueInfo_ClickedProperties = v1_TotalValueInfo_ClickedProperties;
class v1_TrustedContactEntry_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'flow_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_TrustedContactEntry_ViewedProperties = v1_TrustedContactEntry_ViewedProperties;
class v1_TrustedContact_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_TrustedContact_ClickedProperties = v1_TrustedContact_ClickedProperties;
class v1_TrustedContact_SubmittedProperties {
  static Skipped = {
    yes: 'yes',
    no: 'no'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['skipped']);
    var fixedNumber = 0;
    if (!Object.values(v1_TrustedContact_SubmittedProperties.Skipped).includes(this.payload.skipped)) {
      console.error('Invalid skipped value');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['skipped', 'flow_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_TrustedContact_SubmittedProperties = v1_TrustedContact_SubmittedProperties;
class v1_UpgradeModule_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin', 'tier_plan', 'tier_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!(typeof this.payload.tier_plan === 'string' || this.payload.tier_plan instanceof String)) {
      console.error('tier_plan must be of type String');
    }
    if (!(typeof this.payload.tier_type === 'string' || this.payload.tier_type instanceof String)) {
      console.error('tier_type must be of type String');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'tier_plan', 'tier_type', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_UpgradeModule_ClickedProperties = v1_UpgradeModule_ClickedProperties;
class v1_UpgradeModule_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin', 'tier_plan', 'tier_type']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!(typeof this.payload.tier_plan === 'string' || this.payload.tier_plan instanceof String)) {
      console.error('tier_plan must be of type String');
    }
    if (!(typeof this.payload.tier_type === 'string' || this.payload.tier_type instanceof String)) {
      console.error('tier_type must be of type String');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'tier_plan', 'tier_type', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_UpgradeModule_ViewedProperties = v1_UpgradeModule_ViewedProperties;
class v1_UserIdLog_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['user_id']);
    var fixedNumber = 0;
    if (!(typeof this.payload.user_id === 'string' || this.payload.user_id instanceof String)) {
      console.error('user_id must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['user_id']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_UserIdLog_SubmittedProperties = v1_UserIdLog_SubmittedProperties;
class v1_UserIntentQuestion_SubmittedProperties {
  static Answer = {
    bigPurchase: 'big_purchase',
    retirementPlanning: 'retirement_planning',
    emergencyFund: 'emergency_fund',
    buildWealth: 'build_wealth'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['answer', 'flow_type', 'origin', 'variant']);
    var fixedNumber = 0;
    if (!Object.values(v1_UserIntentQuestion_SubmittedProperties.Answer).includes(this.payload.answer)) {
      console.error('Invalid answer value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!(typeof this.payload.variant === 'string' || this.payload.variant instanceof String)) {
      console.error('variant must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['answer', 'flow_type', 'origin', 'variant']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_UserIntentQuestion_SubmittedProperties = v1_UserIntentQuestion_SubmittedProperties;
class v1_UserIntentQuestion_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['flow_type', 'origin', 'variant']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (!(typeof this.payload.variant === 'string' || this.payload.variant instanceof String)) {
      console.error('variant must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'variant']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_UserIntentQuestion_ViewedProperties = v1_UserIntentQuestion_ViewedProperties;
class v1_UserProfile_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['origin']);
    var fixedNumber = 0;
    if (!Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_UserProfile_ClickedProperties = v1_UserProfile_ClickedProperties;
class v1_UserProfile_ViewedProperties {
  static StashworksBanner = {
    yes: 'yes',
    no: 'no'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['stashworks_banner']);
    var fixedNumber = 0;
    if (!Object.values(v1_UserProfile_ViewedProperties.StashworksBanner).includes(this.payload.stashworks_banner)) {
      console.error('Invalid stashworks_banner value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['stashworks_banner']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_UserProfile_ViewedProperties = v1_UserProfile_ViewedProperties;
class v1_UserSignup_ClickedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.screen != null && !Object.values(_enum_properties.Screen).includes(this.payload.screen)) {
      console.error('Invalid screen value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'screen']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_UserSignup_ClickedProperties = v1_UserSignup_ClickedProperties;
class v1_UserSignup_SubmittedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.utm_campaign != null && !(typeof this.payload.utm_campaign === 'string' || this.payload.utm_campaign instanceof String)) {
      console.error('utm_campaign must be of type String');
    }
    if (this.payload.utm_content != null && !(typeof this.payload.utm_content === 'string' || this.payload.utm_content instanceof String)) {
      console.error('utm_content must be of type String');
    }
    if (this.payload.utm_medium != null && !(typeof this.payload.utm_medium === 'string' || this.payload.utm_medium instanceof String)) {
      console.error('utm_medium must be of type String');
    }
    if (this.payload.utm_source != null && !(typeof this.payload.utm_source === 'string' || this.payload.utm_source instanceof String)) {
      console.error('utm_source must be of type String');
    }
    if (this.payload.utm_term != null && !(typeof this.payload.utm_term === 'string' || this.payload.utm_term instanceof String)) {
      console.error('utm_term must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['flow_type', 'origin', 'utm_campaign', 'utm_content', 'utm_medium', 'utm_source', 'utm_term']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_UserSignup_SubmittedProperties = v1_UserSignup_SubmittedProperties;
class v1_UserSignup_ViewedProperties {
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, []);
    var fixedNumber = 0;
    if (this.payload.eid != null && !(typeof this.payload.eid === 'string' || this.payload.eid instanceof String)) {
      console.error('eid must be of type String');
    }
    if (this.payload.flow_type != null && !Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.source != null && !(typeof this.payload.source === 'string' || this.payload.source instanceof String)) {
      console.error('source must be of type String');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['eid', 'flow_type', 'origin', 'source']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_UserSignup_ViewedProperties = v1_UserSignup_ViewedProperties;
class v1_VerifyMicros_ViewedProperties {
  static ExternalAccountConnectionType = {
    instant: 'instant',
    microDeposits: 'micro_deposits'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['external_account_connection_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_VerifyMicros_ViewedProperties.ExternalAccountConnectionType).includes(this.payload.external_account_connection_type)) {
      console.error('Invalid external_account_connection_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['external_account_connection_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_VerifyMicros_ViewedProperties = v1_VerifyMicros_ViewedProperties;
class v1_WithdrawSetup_FailedProperties {
  static ErrorType = {
    apiError: 'api_error'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['error_type', 'flow_type']);
    var fixedNumber = 0;
    if (!Object.values(v1_WithdrawSetup_FailedProperties.ErrorType).includes(this.payload.error_type)) {
      console.error('Invalid error_type value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['error_type', 'flow_type', 'origin']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_WithdrawSetup_FailedProperties = v1_WithdrawSetup_FailedProperties;
class v1_WithdrawSetup_SubmittedProperties {
  static Destination = {
    externalBank: 'external_bank',
    debitCard: 'debit_card'
  };
  static Source = {
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira',
    personalBrokerage: 'personal_brokerage',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank'
  };
  static SourceManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'flow_type', 'frequency_type', 'source']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_WithdrawSetup_SubmittedProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (!Object.values(v1_WithdrawSetup_SubmittedProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.source_management_type != null && !Object.values(v1_WithdrawSetup_SubmittedProperties.SourceManagementType).includes(this.payload.source_management_type)) {
      console.error('Invalid source_management_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'flow_type', 'frequency_type', 'source', 'frequency_schedule', 'origin', 'source_management_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_WithdrawSetup_SubmittedProperties = v1_WithdrawSetup_SubmittedProperties;
class v1_WithdrawSetup_SucceededProperties {
  static Destination = {
    externalBank: 'external_bank',
    debitCard: 'debit_card'
  };
  static Source = {
    rothIra: 'roth_ira',
    traditionalIra: 'traditional_ira',
    personalBrokerage: 'personal_brokerage',
    custodial: 'custodial',
    retirement: 'retirement',
    bank: 'bank'
  };
  static SourceManagementType = {
    robo: 'robo',
    selfDirected: 'self_directed'
  };
  constructor(payload) {
    this.payload = payload ?? {};
  }
  validate() {
    validateRequiredProperties(this.payload, ['amount', 'currency', 'destination', 'flow_type', 'frequency_type', 'source']);
    var fixedNumber = 0;
    fixedNumber = canFixNumber(this.payload.amount);
    if (fixedNumber === false) {
      console.error('amount must be of type Number');
    } else {
      this.payload.amount = fixedNumber;
    }
    if (!(typeof this.payload.currency === 'string' || this.payload.currency instanceof String)) {
      console.error('currency must be of type String');
    }
    if (!Object.values(v1_WithdrawSetup_SucceededProperties.Destination).includes(this.payload.destination)) {
      console.error('Invalid destination value');
    }
    if (!Object.values(_enum_properties.FlowType).includes(this.payload.flow_type)) {
      console.error('Invalid flow_type value');
    }
    if (!Object.values(_enum_properties.FrequencyType).includes(this.payload.frequency_type)) {
      console.error('Invalid frequency_type value');
    }
    if (!Object.values(v1_WithdrawSetup_SucceededProperties.Source).includes(this.payload.source)) {
      console.error('Invalid source value');
    }
    if (this.payload.frequency_schedule != null && !Object.values(_enum_properties.FrequencySchedule).includes(this.payload.frequency_schedule)) {
      console.error('Invalid frequency_schedule value');
    }
    if (this.payload.origin != null && !Object.values(_enum_properties.Origin).includes(this.payload.origin)) {
      console.error('Invalid origin value');
    }
    if (this.payload.source_management_type != null && !Object.values(v1_WithdrawSetup_SucceededProperties.SourceManagementType).includes(this.payload.source_management_type)) {
      console.error('Invalid source_management_type value');
    }
  }
  toJSON() {
    this.validate();
    return clearProperties(this.payload, ['amount', 'currency', 'destination', 'flow_type', 'frequency_type', 'source', 'frequency_schedule', 'origin', 'source_management_type']);
  }
  context() {
    return v1_CONTEXT;
  }
}
exports.v1_WithdrawSetup_SucceededProperties = v1_WithdrawSetup_SucceededProperties;
function validateRequiredProperties(obj, requiredProperties) {
  if (!obj) {
    console.error('Payload is required');
  }
  requiredProperties.forEach(propertyName => {
    if (obj[propertyName] === undefined || obj[propertyName] === null) {
      console.error(`${propertyName} is required`);
    }
  });
}
function clearProperties(obj, allowedProperties) {
  var newObj = {};
  allowedProperties.forEach(propertyName => {
    if (obj[propertyName] !== undefined && obj[propertyName] !== null) {
      var property = obj[propertyName];
      if (property instanceof Date) {
        newObj[propertyName] = property.toISOString();
      } else {
        newObj[propertyName] = obj[propertyName];
      }
    }
  });
  return newObj;
}
function isISODateString(string) {
  const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/;
  return regex.test(string);
}
function canFixNumber(input) {
  if (input === undefined) return false;
  let str = typeof input === 'number' ? input.toString() : input;
  const sanitizedStr = str.replace(/[, $]/g, '');
  const number = parseFloat(sanitizedStr);
  if (isNaN(number)) {
    return false;
  }
  return number;
}
//# sourceMappingURL=properties.js.map